import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { useFetchData } from './codegen-fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

export type AnalysisOutputItem = {
  __typename?: 'AnalysisOutputItem';
  emotion: Scalars['String'];
  evidence?: Maybe<Array<Scalars['String']>>;
  strength?: Maybe<Scalars['Float']>;
};

export type AnalysisOutputItemInput = {
  emotion: Scalars['String'];
  evidence?: InputMaybe<Array<Scalars['String']>>;
  strength?: InputMaybe<Scalars['Float']>;
};

export type Asset = {
  __typename?: 'Asset';
  key: Scalars['String'];
  lastModified: Scalars['String'];
  url: Scalars['String'];
};

export type BaseSong = {
  analysisOutput?: Maybe<FullAnalysisOutput>;
  analysisStatus?: Maybe<SongAnalyisStatus>;
  analyzed: Scalars['Boolean'];
  appleMusicId?: Maybe<Scalars['String']>;
  artist: Scalars['String'];
  artworkUrl?: Maybe<Scalars['String']>;
  ccli?: Maybe<Scalars['Int']>;
  emotionTags: Array<Scalars['String']>;
  energyTags: Array<Scalars['String']>;
  gospelTags: Array<Scalars['String']>;
  id: Scalars['ID'];
  lyrics?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  recommendedKey?: Maybe<Scalars['String']>;
  recordedKey?: Maybe<Scalars['String']>;
  rotationStatus?: Maybe<Scalars['String']>;
  songTypeTags: Array<Scalars['String']>;
  spotifyId?: Maybe<Scalars['String']>;
  themeTags: Array<Scalars['String']>;
  variations: Array<Scalars['String']>;
  youtubeId?: Maybe<Scalars['String']>;
};

export type BibleBook = {
  __typename?: 'BibleBook';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type BibleChapter = {
  __typename?: 'BibleChapter';
  bibleBookCode: Scalars['String'];
  id: Scalars['Int'];
  number: Scalars['Int'];
};

export type BibleVerse = {
  __typename?: 'BibleVerse';
  analysisOutput?: Maybe<FullAnalysisOutput>;
  content: Scalars['String'];
  number: Scalars['Int'];
  reference: Scalars['String'];
};

export type Chat = {
  __typename?: 'Chat';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  messages?: Maybe<MessageResults>;
  name?: Maybe<Scalars['String']>;
  stat?: Maybe<ChatStat>;
  type: Scalars['String'];
  userIds: Array<Scalars['String']>;
  userStats?: Maybe<Array<UserChatStat>>;
  users?: Maybe<Array<User>>;
};


export type ChatMessagesArgs = {
  input: PaginationInput;
};

export type ChatStat = {
  __typename?: 'ChatStat';
  lastSeenAt: Scalars['String'];
};

export enum ChatType {
  Dm = 'DM',
  Group = 'GROUP',
  Video = 'VIDEO'
}

export type Contributor = {
  __typename?: 'Contributor';
  description: Scalars['String'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  role: Scalars['String'];
  videoIds: Array<Scalars['String']>;
  videos?: Maybe<Array<Video>>;
};

export type ContributorInput = {
  description?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  role: Scalars['String'];
};

export type CopilotSongImport = {
  __typename?: 'CopilotSongImport';
  completed: Scalars['Int'];
  total: Scalars['Int'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  id: Scalars['ID'];
  videoCollectionIds: Array<Scalars['String']>;
  videoCollections?: Maybe<Array<VideoCollection>>;
};

export type DashboardInput = {
  videoCollectionIds: Array<Scalars['String']>;
};

export type EmotionalAnalysisOutputItem = {
  __typename?: 'EmotionalAnalysisOutputItem';
  emotion: Scalars['String'];
  strength?: Maybe<Scalars['Float']>;
};

export type EmotionalAnalysisOutputItemInput = {
  emotion: Scalars['String'];
  strength?: InputMaybe<Scalars['Float']>;
};

export type EnrichTag = {
  __typename?: 'EnrichTag';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  keywords: Array<Scalars['String']>;
  tag: Scalars['String'];
  tagColumn: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type EnrichTagInput = {
  keywords: Array<Scalars['String']>;
  tag: Scalars['String'];
  tagColumn: Scalars['String'];
};

export type FullAnalysisOutput = {
  __typename?: 'FullAnalysisOutput';
  emotion?: Maybe<Scalars['String']>;
  emotions: Array<EmotionalAnalysisOutputItem>;
  evidence?: Maybe<Scalars['String']>;
  gospelStory: Array<GospelStoryItem>;
  strength?: Maybe<Scalars['Float']>;
  summary?: Maybe<Scalars['String']>;
  thematicKeywords: Array<ThematicalAnalysisOutputItem>;
  theologicalKeywords: Array<TheologicalAnalysisOutputItem>;
};

export type FullAnalysisOutputInput = {
  emotions: Array<EmotionalAnalysisOutputItemInput>;
  gospelStory: Array<GospelStoryItemInput>;
  summary: Scalars['String'];
  thematicKeywords: Array<ThematicalAnalysisOutputItemInput>;
  theologicalKeywords: Array<TheologicalAnalysisOutputItemInput>;
};

export type GenerateSetlistDefinitionInput = {
  global?: InputMaybe<GenerateSetlistRequestInput>;
  positions: Array<GenerateSetlistRequestInput>;
};

export type GenerateSetlistRequestInput = {
  bibleReference?: InputMaybe<Scalars['String']>;
  bibleVerseReference?: InputMaybe<Scalars['String']>;
  emotionTags?: InputMaybe<Array<Scalars['String']>>;
  energyTags?: InputMaybe<Array<Scalars['String']>>;
  gospelTags?: InputMaybe<Array<Scalars['String']>>;
  isPostSermon?: InputMaybe<Scalars['Boolean']>;
  rotationStatus?: InputMaybe<Array<Scalars['String']>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  songTypeTags?: InputMaybe<Array<Scalars['String']>>;
  teamSongId?: InputMaybe<Scalars['String']>;
};

export type GenerateSetlistSettings = {
  __typename?: 'GenerateSetlistSettings';
  bibleReference?: Maybe<Scalars['String']>;
  bibleVerseReference?: Maybe<Scalars['String']>;
  postSermonSongPosition?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
  totalSongPositions?: Maybe<Scalars['Int']>;
};

export type GenerateSetlistSettingsInput = {
  bibleReference?: InputMaybe<Scalars['String']>;
  bibleVerseReference?: InputMaybe<Scalars['String']>;
  postSermonSongPosition?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  totalSongPositions?: InputMaybe<Scalars['Int']>;
};

export type GeneratedSetlist = {
  __typename?: 'GeneratedSetlist';
  positions: Array<Maybe<TeamSong>>;
  reasoning?: Maybe<Scalars['JSON']>;
};

export type GeneratedSetlistPosition = {
  __typename?: 'GeneratedSetlistPosition';
  teamSong: TeamSong;
};

export type GospelStoryItem = {
  __typename?: 'GospelStoryItem';
  strength?: Maybe<Scalars['Float']>;
  tag: Scalars['String'];
};

export type GospelStoryItemInput = {
  strength?: InputMaybe<Scalars['Float']>;
  tag: Scalars['String'];
};

export type Invite = {
  __typename?: 'Invite';
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type LyricsAndPassageSummary = {
  __typename?: 'LyricsAndPassageSummary';
  lyrics: Scalars['String'];
  passage: Scalars['String'];
  summary: Scalars['String'];
};

export type LyricsAndPassageSummaryInput = {
  lyrics: Scalars['String'];
  reference: Scalars['String'];
  title: Scalars['String'];
};

export type Membership = {
  __typename?: 'Membership';
  roles: Array<Scalars['String']>;
  user: User;
  userId: Scalars['String'];
};

export type Message = {
  __typename?: 'Message';
  content: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['String']>;
  reactions: Array<Reaction>;
  type: MessageType;
  user?: Maybe<User>;
  userId: Scalars['String'];
};

export type MessageInput = {
  content: Scalars['String'];
  id: Scalars['ID'];
  metadata?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MessageType>;
};

export type MessageResults = {
  __typename?: 'MessageResults';
  count: Scalars['Int'];
  items: Array<Message>;
  totalCount: Scalars['Int'];
};

export enum MessageType {
  Setlist = 'SETLIST',
  Songlist = 'SONGLIST',
  Status = 'STATUS',
  Text = 'TEXT'
}

export type Mutation = {
  __typename?: 'Mutation';
  addSongsToMyTeam: Array<TeamSong>;
  analyzeBiblePassage?: Maybe<Scalars['String']>;
  analyzeLyrics?: Maybe<Scalars['String']>;
  cancelSongsImportUpload: SongImport;
  clearGenerateSetlistCache: Scalars['Boolean'];
  createContributor: Contributor;
  createDashboard: Dashboard;
  createEnrichTag: EnrichTag;
  createInvite?: Maybe<Invite>;
  createMessageReaction: Reaction;
  createReel: Reel;
  createSetlist: Setlist;
  createSetlistFeedbackSubmission: SetlistFeedbackSubmission;
  createSong: Song;
  createSongWeight: SongWeight;
  createTeamService: Service;
  createTeamSong: TeamSong;
  createVideo: Video;
  createVideoCollection: VideoCollection;
  deleteContributor: Contributor;
  deleteEnrichTag: EnrichTag;
  deleteInvite?: Maybe<Invite>;
  deleteMyUser: User;
  deleteReel: Reel;
  deleteSetlist: Setlist;
  deleteSong: Song;
  deleteSongWeight: SongWeight;
  deleteTeamService: Service;
  deleteTeamSong: TeamSong;
  deleteVideo: Video;
  deleteVideoCollection: VideoCollection;
  demoteUserToTeamMember: Scalars['Boolean'];
  generateSetlist: GeneratedSetlist;
  getAllWeightedTeamSongs: Array<WeightedTeamSong>;
  getBiblePassageAnalysis?: Maybe<FullAnalysisOutput>;
  getChargebeePortalSession?: Maybe<Scalars['String']>;
  getChat: Chat;
  getChatReactions: Array<Reaction>;
  getChatStats: Array<Reaction>;
  getLyricsAndPassageSummary?: Maybe<LyricsAndPassageSummary>;
  getMessageReactions: Array<Reaction>;
  getSetlistSummary?: Maybe<SetlistSummary>;
  getSong: Song;
  getSongCollection: SongCollection;
  getSongSummary?: Maybe<SongSummary>;
  getTeamSong: TeamSong;
  getVideoChat: VideoChat;
  leaveChat: Chat;
  linkTeamChargebeeCustomer: Scalars['Boolean'];
  mergeSongs: Scalars['Boolean'];
  processSongsImportUpload: SongImport;
  promoteUserToTeamAdmin: Scalars['Boolean'];
  readSongsImportUpload: SongImportColumns;
  reanalyzeSong: Song;
  reanalyzeSongs: Scalars['Int'];
  removeUserFromTeam: Scalars['Boolean'];
  renameChat: Chat;
  requestSongImportUpload: SongImportUpload;
  resendInvite?: Maybe<Invite>;
  searchSongs: SongResults;
  sendChatMessage: Scalars['Boolean'];
  sendChatTypingStatus: Scalars['Boolean'];
  sendCode: Scalars['Boolean'];
  sendVideoChatMessage: Scalars['Boolean'];
  sendVideoChatTypingStatus: Scalars['Boolean'];
  testEnrich?: Maybe<Scalars['String']>;
  testNotifications?: Maybe<Scalars['Boolean']>;
  updateChat: Chat;
  updateContributor: Contributor;
  updateDashboard: Dashboard;
  updateEnrichTag: EnrichTag;
  updateLastSeenAt: User;
  updateMyTeam?: Maybe<Team>;
  updateMyUser: User;
  updateReel: Reel;
  updateSetlist: Setlist;
  updateSong: Song;
  updateSongWeight: SongWeight;
  updateTeamService: Service;
  updateTeamSong: TeamSong;
  updateVideo: Video;
  updateVideoCollection: VideoCollection;
  upsertChat: Chat;
  upsertChatStat: ChatStat;
  upsertReelStat: ReelStat;
  upsertVideoCollectionStat: Scalars['Boolean'];
  upsertVideoStat: VideoStat;
  verifySongsImportUpload: SongImport;
};


export type MutationAddSongsToMyTeamArgs = {
  songIds: Array<Scalars['String']>;
};


export type MutationAnalyzeBiblePassageArgs = {
  text: Scalars['String'];
};


export type MutationAnalyzeLyricsArgs = {
  text: Scalars['String'];
};


export type MutationCancelSongsImportUploadArgs = {
  uploadKey: Scalars['String'];
};


export type MutationCreateContributorArgs = {
  input: ContributorInput;
};


export type MutationCreateDashboardArgs = {
  input: DashboardInput;
};


export type MutationCreateEnrichTagArgs = {
  input: EnrichTagInput;
};


export type MutationCreateInviteArgs = {
  email: Scalars['String'];
  shouldBeAdmin: Scalars['Boolean'];
};


export type MutationCreateMessageReactionArgs = {
  emojiCode: Scalars['String'];
  messageId: Scalars['String'];
};


export type MutationCreateReelArgs = {
  input: ReelInput;
};


export type MutationCreateSetlistArgs = {
  input: SetlistInput;
};


export type MutationCreateSetlistFeedbackSubmissionArgs = {
  input: SetlistFeedbackSubmissionInput;
};


export type MutationCreateSongArgs = {
  input: SongInput;
};


export type MutationCreateSongWeightArgs = {
  input: SongWeightInput;
};


export type MutationCreateTeamServiceArgs = {
  input: ServiceInput;
};


export type MutationCreateTeamSongArgs = {
  input: TeamSongInput;
};


export type MutationCreateVideoArgs = {
  input: VideoInput;
};


export type MutationCreateVideoCollectionArgs = {
  input: VideoCollectionInput;
};


export type MutationDeleteContributorArgs = {
  contributorId: Scalars['String'];
};


export type MutationDeleteEnrichTagArgs = {
  enrichTagId: Scalars['String'];
};


export type MutationDeleteInviteArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMyUserArgs = {
  code: Scalars['String'];
};


export type MutationDeleteReelArgs = {
  reelId: Scalars['String'];
};


export type MutationDeleteSetlistArgs = {
  setlistId: Scalars['String'];
};


export type MutationDeleteSongArgs = {
  songId: Scalars['String'];
};


export type MutationDeleteSongWeightArgs = {
  weightId: Scalars['String'];
};


export type MutationDeleteTeamServiceArgs = {
  serviceId: Scalars['String'];
};


export type MutationDeleteTeamSongArgs = {
  teamSongId: Scalars['String'];
};


export type MutationDeleteVideoArgs = {
  videoId: Scalars['String'];
};


export type MutationDeleteVideoCollectionArgs = {
  videoCollectionId: Scalars['String'];
};


export type MutationDemoteUserToTeamMemberArgs = {
  userId: Scalars['String'];
};


export type MutationGenerateSetlistArgs = {
  request: GenerateSetlistDefinitionInput;
  teamId: Scalars['String'];
};


export type MutationGetAllWeightedTeamSongsArgs = {
  request: GenerateSetlistRequestInput;
  teamId: Scalars['String'];
};


export type MutationGetBiblePassageAnalysisArgs = {
  reference: Scalars['String'];
};


export type MutationGetChatArgs = {
  chatId: Scalars['String'];
};


export type MutationGetChatReactionsArgs = {
  chatId: Scalars['String'];
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type MutationGetChatStatsArgs = {
  chatId: Scalars['String'];
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
};


export type MutationGetLyricsAndPassageSummaryArgs = {
  input: LyricsAndPassageSummaryInput;
};


export type MutationGetMessageReactionsArgs = {
  messageId: Scalars['String'];
};


export type MutationGetSetlistSummaryArgs = {
  teamSongIds: Array<Scalars['String']>;
};


export type MutationGetSongArgs = {
  songId: Scalars['String'];
};


export type MutationGetSongCollectionArgs = {
  collectionId: Scalars['String'];
};


export type MutationGetSongSummaryArgs = {
  teamSongId: Scalars['String'];
};


export type MutationGetTeamSongArgs = {
  teamSongId: Scalars['String'];
};


export type MutationGetVideoChatArgs = {
  videoId: Scalars['String'];
};


export type MutationLeaveChatArgs = {
  chatId: Scalars['String'];
};


export type MutationMergeSongsArgs = {
  songIds: Array<Scalars['String']>;
};


export type MutationProcessSongsImportUploadArgs = {
  settings?: InputMaybe<SongImportSettingsInput>;
  uploadKey: Scalars['String'];
};


export type MutationPromoteUserToTeamAdminArgs = {
  userId: Scalars['String'];
};


export type MutationReadSongsImportUploadArgs = {
  uploadKey: Scalars['String'];
};


export type MutationReanalyzeSongArgs = {
  songId: Scalars['String'];
};


export type MutationRemoveUserFromTeamArgs = {
  userId: Scalars['String'];
};


export type MutationRenameChatArgs = {
  chatId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationResendInviteArgs = {
  id: Scalars['String'];
};


export type MutationSearchSongsArgs = {
  excludeMyTeamSongs?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<SearchSongsFilters>;
  input: PaginationInput;
};


export type MutationSendChatMessageArgs = {
  chatId: Scalars['String'];
  input: MessageInput;
};


export type MutationSendChatTypingStatusArgs = {
  chatId: Scalars['String'];
};


export type MutationSendVideoChatMessageArgs = {
  input: MessageInput;
  videoId: Scalars['String'];
};


export type MutationSendVideoChatTypingStatusArgs = {
  chatId: Scalars['String'];
};


export type MutationTestEnrichArgs = {
  text: Scalars['String'];
};


export type MutationTestNotificationsArgs = {
  input?: InputMaybe<TestNotificationsInput>;
};


export type MutationUpdateChatArgs = {
  chatId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};


export type MutationUpdateContributorArgs = {
  contributorId: Scalars['String'];
  input: ContributorInput;
};


export type MutationUpdateDashboardArgs = {
  input: DashboardInput;
};


export type MutationUpdateEnrichTagArgs = {
  enrichTagId: Scalars['String'];
  input: EnrichTagInput;
};


export type MutationUpdateMyTeamArgs = {
  input: TeamInput;
};


export type MutationUpdateMyUserArgs = {
  input: UserInput;
};


export type MutationUpdateReelArgs = {
  input: ReelInput;
  reelId: Scalars['String'];
};


export type MutationUpdateSetlistArgs = {
  input: SetlistInput;
  setlistId: Scalars['String'];
};


export type MutationUpdateSongArgs = {
  input: SongInput;
  songId: Scalars['String'];
};


export type MutationUpdateSongWeightArgs = {
  input: SongWeightInput;
  weightId: Scalars['String'];
};


export type MutationUpdateTeamServiceArgs = {
  input: ServiceInput;
  serviceId: Scalars['String'];
};


export type MutationUpdateTeamSongArgs = {
  input: TeamSongInput;
  teamSongId: Scalars['String'];
};


export type MutationUpdateVideoArgs = {
  input: VideoInput;
  videoId: Scalars['String'];
};


export type MutationUpdateVideoCollectionArgs = {
  input: VideoCollectionInput;
  videoCollectionId: Scalars['String'];
};


export type MutationUpsertChatArgs = {
  userIds: Array<Scalars['String']>;
};


export type MutationUpsertChatStatArgs = {
  chatId: Scalars['String'];
};


export type MutationUpsertReelStatArgs = {
  input: ReelStatInput;
  reelId: Scalars['String'];
};


export type MutationUpsertVideoCollectionStatArgs = {
  input: VideoCollectionStatInput;
  videoCollectionId: Scalars['String'];
};


export type MutationUpsertVideoStatArgs = {
  input: VideoStatInput;
  videoId: Scalars['String'];
};


export type MutationVerifySongsImportUploadArgs = {
  settings?: InputMaybe<SongImportSettingsInput>;
  uploadKey: Scalars['String'];
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  chat: Scalars['Boolean'];
  groupChat: Scalars['Boolean'];
  reEngagementNudge: Scalars['Boolean'];
  videoChat: Scalars['Boolean'];
  videoChatActiveOnly: Scalars['Boolean'];
};

export type NotificationPreferencesInput = {
  chat: Scalars['Boolean'];
  groupChat: Scalars['Boolean'];
  reEngagementNudge: Scalars['Boolean'];
  videoChat: Scalars['Boolean'];
  videoChatActiveOnly: Scalars['Boolean'];
};

export enum NotificationResourceType {
  Dm = 'DM',
  GroupChat = 'GROUP_CHAT',
  VideoChat = 'VIDEO_CHAT'
}

export type PaginationInput = {
  afterDate?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<SortDirection>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  sortBy?: InputMaybe<Scalars['String']>;
};

export type PcoSong = {
  artist: Scalars['String'];
  author?: InputMaybe<Scalars['String']>;
  ccli?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  recordedKey?: InputMaybe<Scalars['String']>;
};

export enum Permissions {
  ChargebeeCustomerLink = 'ChargebeeCustomerLink',
  ChargebeeSessionGet = 'ChargebeeSessionGet',
  ChargebeeSubscriptionCheck = 'ChargebeeSubscriptionCheck',
  ChatCreate = 'ChatCreate',
  ChatUpdate = 'ChatUpdate',
  ContributorCreate = 'ContributorCreate',
  ContributorDelete = 'ContributorDelete',
  ContributorUpdate = 'ContributorUpdate',
  DashboardCreate = 'DashboardCreate',
  DashboardGet = 'DashboardGet',
  DashboardUpdate = 'DashboardUpdate',
  DevFeatureRead = 'DevFeatureRead',
  DevtoolsRead = 'DevtoolsRead',
  EnrichTagCreate = 'EnrichTagCreate',
  EnrichTagDelete = 'EnrichTagDelete',
  EnrichTagList = 'EnrichTagList',
  EnrichTagUpdate = 'EnrichTagUpdate',
  InviteCreate = 'InviteCreate',
  InviteDelete = 'InviteDelete',
  MembershipCreate = 'MembershipCreate',
  MembershipDelete = 'MembershipDelete',
  MembershipUpdate = 'MembershipUpdate',
  ReelCreate = 'ReelCreate',
  ReelDelete = 'ReelDelete',
  ReelFeedGet = 'ReelFeedGet',
  ReelGet = 'ReelGet',
  ReelList = 'ReelList',
  ReelStatCreate = 'ReelStatCreate',
  ReelStatUpdate = 'ReelStatUpdate',
  ReelUpdate = 'ReelUpdate',
  ServiceCreate = 'ServiceCreate',
  ServiceDelete = 'ServiceDelete',
  ServiceGet = 'ServiceGet',
  ServiceList = 'ServiceList',
  ServiceUpdate = 'ServiceUpdate',
  SetlistCreate = 'SetlistCreate',
  SetlistDelete = 'SetlistDelete',
  SetlistGet = 'SetlistGet',
  SetlistList = 'SetlistList',
  SetlistUpdate = 'SetlistUpdate',
  SongCreate = 'SongCreate',
  SongDelete = 'SongDelete',
  SongList = 'SongList',
  SongUpdate = 'SongUpdate',
  SongWeightCreate = 'SongWeightCreate',
  SongWeightDelete = 'SongWeightDelete',
  SongWeightGet = 'SongWeightGet',
  SongWeightList = 'SongWeightList',
  SongWeightUpdate = 'SongWeightUpdate',
  SonglistUpdate = 'SonglistUpdate',
  SubscriptionCreate = 'SubscriptionCreate',
  SubscriptionUpdate = 'SubscriptionUpdate',
  TeamDelete = 'TeamDelete',
  TeamList = 'TeamList',
  TeamSongCreate = 'TeamSongCreate',
  TeamSongDelete = 'TeamSongDelete',
  TeamSongList = 'TeamSongList',
  TeamSongUpdate = 'TeamSongUpdate',
  TeamUpdate = 'TeamUpdate',
  VideoChatCreate = 'VideoChatCreate',
  VideoChatUpdate = 'VideoChatUpdate',
  VideoCollectionCreate = 'VideoCollectionCreate',
  VideoCollectionDelete = 'VideoCollectionDelete',
  VideoCollectionGet = 'VideoCollectionGet',
  VideoCollectionList = 'VideoCollectionList',
  VideoCollectionUpdate = 'VideoCollectionUpdate',
  VideoCreate = 'VideoCreate',
  VideoDelete = 'VideoDelete',
  VideoGet = 'VideoGet',
  VideoList = 'VideoList',
  VideoUpdate = 'VideoUpdate',
  WeightedTeamSongList = 'WeightedTeamSongList'
}

export type PipelineJob = {
  __typename?: 'PipelineJob';
  dashUrl: Scalars['String'];
  duration: Scalars['Int'];
  endTime?: Maybe<Scalars['String']>;
  frameCaptureHeight: Scalars['Int'];
  frameCaptureWidth: Scalars['Int'];
  guid: Scalars['ID'];
  hlsUrl: Scalars['String'];
  srcVideo: Scalars['String'];
  startTime: Scalars['String'];
  thumbNailsUrls: Scalars['String'];
  workflowStatus: Scalars['String'];
};

export type PipelineJobsFilter = {
  srcVideo?: InputMaybe<Scalars['String']>;
};

export type QuartileData = {
  __typename?: 'QuartileData';
  q1: Scalars['Float'];
  q2: Scalars['Float'];
  q3: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  checkAndSetChargebeeSubscription: Scalars['Boolean'];
  getBiblePassageAnalysis?: Maybe<FullAnalysisOutput>;
  getBibleVerse?: Maybe<BibleVerse>;
  getChat: Chat;
  getContributor: Contributor;
  getDashboard: Dashboard;
  getMyPermissions: Array<Scalars['String']>;
  getMyTeam: Team;
  getMyUser: User;
  getPipelineJob: PipelineJob;
  getReel: Reel;
  getReelFeed: Array<Reel>;
  getSetlist: Setlist;
  getSong: Song;
  getSongWeight: SongWeight;
  getSongsImport: SongImport;
  getTeamService: Service;
  getTeamSetlist: Setlist;
  getTeamSong: TeamSong;
  getTeamSongs: Array<Maybe<TeamSong>>;
  getUserTopTeamSongs?: Maybe<Array<UserTopTeamSong>>;
  getVideo: Video;
  getVideoChat: VideoChat;
  getVideoCollection: VideoCollection;
  isChargebeeCouponUsable: Scalars['Boolean'];
  listAssets: Array<Asset>;
  listBibleBooks: Array<BibleBook>;
  listBibleChapters: Array<BibleChapter>;
  listBibleVerses: Array<BibleVerse>;
  listContributors: Array<Maybe<Contributor>>;
  listEnrichTags: Array<EnrichTag>;
  listInvites?: Maybe<Array<Maybe<Invite>>>;
  listMyChats: Array<Chat>;
  listMySetlistFeedbackRequests: Array<Setlist>;
  listMySetlists: Array<Setlist>;
  listMyTeamSetlists: Array<Setlist>;
  listMyTeamSongs: Array<TeamSong>;
  listPipelineJobs: Array<Maybe<PipelineJob>>;
  listReels: Array<Reel>;
  listSetlistsByChatId: Array<Setlist>;
  listSongWeights: Array<SongWeight>;
  listSongs: Array<Song>;
  listTeamServices: Array<Service>;
  listTeamSongs: Array<TeamSong>;
  listTeamVideoChats: Array<VideoChat>;
  listTeams: Array<Team>;
  listUsers?: Maybe<Array<Maybe<User>>>;
  listVideoCollections: Array<VideoCollection>;
  listVideos: Array<Maybe<Video>>;
  ping: Scalars['String'];
};


export type QueryGetBiblePassageAnalysisArgs = {
  reference: Scalars['String'];
};


export type QueryGetBibleVerseArgs = {
  reference: Scalars['String'];
};


export type QueryGetChatArgs = {
  chatId: Scalars['String'];
};


export type QueryGetContributorArgs = {
  id: Scalars['String'];
};


export type QueryGetPipelineJobArgs = {
  guid: Scalars['String'];
};


export type QueryGetReelArgs = {
  id: Scalars['String'];
};


export type QueryGetSetlistArgs = {
  setlistId: Scalars['String'];
};


export type QueryGetSongArgs = {
  songId: Scalars['String'];
};


export type QueryGetSongWeightArgs = {
  weightId: Scalars['String'];
};


export type QueryGetSongsImportArgs = {
  uploadKey: Scalars['String'];
};


export type QueryGetTeamServiceArgs = {
  serviceId: Scalars['String'];
};


export type QueryGetTeamSetlistArgs = {
  setlistId: Scalars['String'];
};


export type QueryGetTeamSongArgs = {
  teamSongId: Scalars['String'];
};


export type QueryGetTeamSongsArgs = {
  teamSongIds: Array<Scalars['String']>;
};


export type QueryGetUserTopTeamSongsArgs = {
  userId: Scalars['String'];
};


export type QueryGetVideoArgs = {
  id: Scalars['String'];
};


export type QueryGetVideoChatArgs = {
  videoId: Scalars['String'];
};


export type QueryGetVideoCollectionArgs = {
  videoCollectionId: Scalars['String'];
};


export type QueryIsChargebeeCouponUsableArgs = {
  couponId: Scalars['String'];
};


export type QueryListBibleChaptersArgs = {
  bookCode: Scalars['String'];
};


export type QueryListBibleVersesArgs = {
  chapterId: Scalars['Int'];
};


export type QueryListMyChatsArgs = {
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryListPipelineJobsArgs = {
  filter: PipelineJobsFilter;
};


export type QueryListSetlistsByChatIdArgs = {
  chatId: Scalars['String'];
  input: PaginationInput;
};


export type QueryListTeamSongsArgs = {
  teamId: Scalars['String'];
};


export type QueryListTeamVideoChatsArgs = {
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};

export type Reaction = {
  __typename?: 'Reaction';
  createdAt: Scalars['String'];
  emojiCode: Scalars['String'];
  id: Scalars['ID'];
  messageId: Scalars['ID'];
  user?: Maybe<User>;
  userId: Scalars['String'];
};

export type Reel = {
  __typename?: 'Reel';
  id: Scalars['ID'];
  name: Scalars['String'];
  posterUrl: Scalars['String'];
  stat?: Maybe<ReelStat>;
  url: Scalars['String'];
  video?: Maybe<Video>;
  videoId: Scalars['ID'];
};

export type ReelInput = {
  name: Scalars['String'];
  posterUrl: Scalars['String'];
  url: Scalars['String'];
  videoId: Scalars['ID'];
};

export type ReelStat = {
  __typename?: 'ReelStat';
  liked: Scalars['Boolean'];
};

export type ReelStatInput = {
  liked: Scalars['Boolean'];
};

export type SearchSongsFilters = {
  onlySongIds?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  tagsByCategory?: InputMaybe<TagsByCategoryFilter>;
  term?: InputMaybe<Scalars['String']>;
  withLyrics?: InputMaybe<Scalars['Boolean']>;
};

export type Service = {
  __typename?: 'Service';
  createdAt: Scalars['String'];
  day: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  size?: Maybe<Scalars['String']>;
  startAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ServiceInput = {
  day: Scalars['Int'];
  name: Scalars['String'];
  size?: InputMaybe<Scalars['String']>;
  startAt: Scalars['String'];
};

export type Setlist = {
  __typename?: 'Setlist';
  chat?: Maybe<Chat>;
  chatId: Scalars['ID'];
  createdAt: Scalars['String'];
  draft: Scalars['Boolean'];
  feedback?: Maybe<SetlistFeedback>;
  generateSettings?: Maybe<GenerateSetlistSettings>;
  id: Scalars['ID'];
  serviceId?: Maybe<Scalars['ID']>;
  startAt: Scalars['String'];
  submissions?: Maybe<Array<SetlistFeedbackSubmission>>;
  teamId: Scalars['ID'];
  teamSongIds: Array<Scalars['ID']>;
  teamSongOverrides: Array<SetlistTeamSong>;
  teamSongs: Array<Maybe<TeamSong>>;
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export type SetlistFeedback = {
  __typename?: 'SetlistFeedback';
  congregationalScoreQuartiles: QuartileData;
  overallScore: Scalars['Float'];
  personalScoreQuartiles: QuartileData;
  setlistId: Scalars['String'];
  submissions: Array<SetlistFeedbackSubmission>;
  teamScoreQuartiles: QuartileData;
  teamSongFeedbackReports: Array<TeamSongFeedbackReport>;
};

export type SetlistFeedbackSubmission = {
  __typename?: 'SetlistFeedbackSubmission';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  setlistId: Scalars['String'];
  teamSongFeedbackSubmissionIds: Array<Scalars['String']>;
  teamSongFeedbackSubmissions: Array<TeamSongFeedbackSubmission>;
  userId: Scalars['String'];
};

export type SetlistFeedbackSubmissionInput = {
  setlistId: Scalars['String'];
  teamSongFeedbackSubmissions: Array<TeamSongFeedbackSubmissionInput>;
};

export type SetlistInput = {
  chatId?: InputMaybe<Scalars['ID']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  generateSettings?: InputMaybe<GenerateSetlistSettingsInput>;
  serviceId?: InputMaybe<Scalars['String']>;
  startAt: Scalars['String'];
  teamSongIds: Array<Scalars['ID']>;
  teamSongOverrides?: InputMaybe<Array<SetlistTeamSongInput>>;
};

export type SetlistSummary = {
  __typename?: 'SetlistSummary';
  emotions: Scalars['String'];
  energy: Scalars['String'];
  gospel_story: Scalars['String'];
  recommendations: Scalars['String'];
  summary: Scalars['String'];
  themes: Scalars['String'];
  theology: Scalars['String'];
};

export type SetlistTeamSong = {
  __typename?: 'SetlistTeamSong';
  defaultKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type SetlistTeamSongInput = {
  defaultKey?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type Song = BaseSong & {
  __typename?: 'Song';
  analysisOutput?: Maybe<FullAnalysisOutput>;
  analysisStatus?: Maybe<SongAnalyisStatus>;
  analyzed: Scalars['Boolean'];
  appleMusicId?: Maybe<Scalars['String']>;
  artist: Scalars['String'];
  artworkUrl?: Maybe<Scalars['String']>;
  ccli?: Maybe<Scalars['Int']>;
  emotionTags: Array<Scalars['String']>;
  energyTags: Array<Scalars['String']>;
  gospelTags: Array<Scalars['String']>;
  id: Scalars['ID'];
  lyrics?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  recommendedKey?: Maybe<Scalars['String']>;
  recordedKey?: Maybe<Scalars['String']>;
  rotationStatus?: Maybe<Scalars['String']>;
  songTypeTags: Array<Scalars['String']>;
  spotifyId?: Maybe<Scalars['String']>;
  teamCount?: Maybe<Scalars['Int']>;
  themeTags: Array<Scalars['String']>;
  variations: Array<Scalars['String']>;
  youtubeId?: Maybe<Scalars['String']>;
};

export enum SongAnalyisStatus {
  Analyzing = 'Analyzing',
  Completed = 'Completed',
  Error = 'Error',
  Waiting = 'Waiting'
}

export type SongCollection = {
  __typename?: 'SongCollection';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  songIds: Array<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type SongCollectionInput = {
  global?: InputMaybe<GenerateSetlistRequestInput>;
  positions: Array<GenerateSetlistRequestInput>;
};

export type SongImport = {
  __typename?: 'SongImport';
  cancelledAt?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  createdSongs: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  matchedSongs: Scalars['Int'];
  phase: Scalars['String'];
  progress: Scalars['Int'];
  report?: Maybe<SongImportReport>;
  totalSongs: Scalars['Int'];
  uploadKey: Scalars['String'];
};

export type SongImportColumnAliasesInput = {
  artist?: InputMaybe<Scalars['String']>;
  ccli?: InputMaybe<Scalars['String']>;
  defaultKey?: InputMaybe<Scalars['String']>;
  energy?: InputMaybe<Scalars['String']>;
  lyrics?: InputMaybe<Scalars['String']>;
  spotifyUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type SongImportColumns = {
  __typename?: 'SongImportColumns';
  columns: Array<Scalars['String']>;
  rowCount: Scalars['Int'];
};

export type SongImportReport = {
  __typename?: 'SongImportReport';
  existingOnTeam: Array<Scalars['String']>;
  matchedSongIds: Array<Scalars['String']>;
  missingLyrics: Array<Scalars['String']>;
  newSongs: Array<Scalars['String']>;
  sample: Array<SongImportRowPreview>;
  totalSongs: Scalars['Int'];
};

export type SongImportRowPreview = {
  __typename?: 'SongImportRowPreview';
  artist: Scalars['String'];
  artworkUrl?: Maybe<Scalars['String']>;
  defaultKey?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SongImportSettingsInput = {
  columnAliases?: InputMaybe<SongImportColumnAliasesInput>;
};

export type SongImportUpload = {
  __typename?: 'SongImportUpload';
  key: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type SongInput = {
  analysisOutput?: InputMaybe<FullAnalysisOutputInput>;
  analysisStatus?: InputMaybe<SongAnalyisStatus>;
  appleMusicId?: InputMaybe<Scalars['String']>;
  artist: Scalars['String'];
  artworkUrl?: InputMaybe<Scalars['String']>;
  ccli?: InputMaybe<Scalars['Int']>;
  emotionTags?: InputMaybe<Array<Scalars['String']>>;
  energyTags?: InputMaybe<Array<Scalars['String']>>;
  gospelTags?: InputMaybe<Array<Scalars['String']>>;
  lyrics?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  recommendedKey?: InputMaybe<Scalars['String']>;
  recordedKey?: InputMaybe<Scalars['String']>;
  rotationStatus?: InputMaybe<Scalars['String']>;
  songTypeTags?: InputMaybe<Array<Scalars['String']>>;
  spotifyId?: InputMaybe<Scalars['String']>;
  variations?: InputMaybe<Array<Scalars['String']>>;
  youtubeId?: InputMaybe<Scalars['String']>;
};

export type SongResults = {
  __typename?: 'SongResults';
  count: Scalars['Int'];
  items: Array<Song>;
  totalCount: Scalars['Int'];
};

export type SongSummary = {
  __typename?: 'SongSummary';
  emotions: Scalars['String'];
  gospel_story: Scalars['String'];
  summary: Scalars['String'];
  themes: Scalars['String'];
  theology: Scalars['String'];
};

export type SongWeight = {
  __typename?: 'SongWeight';
  description?: Maybe<Scalars['String']>;
  function: Scalars['String'];
  highValue: Scalars['Int'];
  id: Scalars['ID'];
  key: Scalars['String'];
  lowValue: Scalars['Int'];
  name: Scalars['String'];
};

export type SongWeightInput = {
  description?: InputMaybe<Scalars['String']>;
  function: Scalars['String'];
  highValue: Scalars['Int'];
  key: Scalars['String'];
  lowValue: Scalars['Int'];
  name: Scalars['String'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  teamAction?: Maybe<TeamAction>;
};

export type TagsByCategoryFilter = {
  emotionTags: Array<Scalars['String']>;
  energyTags: Array<Scalars['String']>;
  gospelTags: Array<Scalars['String']>;
  songTypeTags: Array<Scalars['String']>;
};

export type Team = {
  __typename?: 'Team';
  chartRepositoryUrl?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  denomination?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inviteLinkCode: Scalars['String'];
  invites?: Maybe<Array<Maybe<Invite>>>;
  members: Array<Membership>;
  name: Scalars['String'];
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptionStatus: Scalars['Boolean'];
};

export type TeamAction = {
  __typename?: 'TeamAction';
  action: TeamActionActions;
  actorId: Scalars['String'];
  resourceIds: Array<Scalars['String']>;
};

export enum TeamActionActions {
  ChatChanged = 'CHAT_CHANGED',
  ChatLastSeenChanged = 'CHAT_LAST_SEEN_CHANGED',
  ChatMessageSent = 'CHAT_MESSAGE_SENT',
  ChatReactionSent = 'CHAT_REACTION_SENT',
  ChatTypingStatus = 'CHAT_TYPING_STATUS',
  ServiceChanged = 'SERVICE_CHANGED',
  SetlistsChanged = 'SETLISTS_CHANGED',
  TeamChanged = 'TEAM_CHANGED',
  TeamSongsChanged = 'TEAM_SONGS_CHANGED',
  VideoChatChanged = 'VIDEO_CHAT_CHANGED',
  VideoChatTypingStatus = 'VIDEO_CHAT_TYPING_STATUS'
}

export type TeamInput = {
  chartRepositoryUrl?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  denomination?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type TeamSong = BaseSong & {
  __typename?: 'TeamSong';
  analysisOutput?: Maybe<FullAnalysisOutput>;
  analysisStatus?: Maybe<SongAnalyisStatus>;
  analyzed: Scalars['Boolean'];
  appleMusicId?: Maybe<Scalars['String']>;
  artist: Scalars['String'];
  artworkUrl?: Maybe<Scalars['String']>;
  candidateSongId?: Maybe<Scalars['ID']>;
  ccli?: Maybe<Scalars['Int']>;
  createdAt: Scalars['String'];
  defaultKey?: Maybe<Scalars['String']>;
  emotionTags: Array<Scalars['String']>;
  energyTags: Array<Scalars['String']>;
  feedback?: Maybe<TeamSongFeedback>;
  gospelTags: Array<Scalars['String']>;
  id: Scalars['ID'];
  lyrics?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  new: Scalars['Boolean'];
  originSongId?: Maybe<Scalars['ID']>;
  recommendedKey?: Maybe<Scalars['String']>;
  recordedKey?: Maybe<Scalars['String']>;
  rotationStatus?: Maybe<Scalars['String']>;
  setlists?: Maybe<Array<Setlist>>;
  songTypeTags: Array<Scalars['String']>;
  spotifyId?: Maybe<Scalars['String']>;
  teamId: Scalars['ID'];
  themeTags: Array<Scalars['String']>;
  variations: Array<Scalars['String']>;
  youtubeId?: Maybe<Scalars['String']>;
};

export type TeamSongFeedback = {
  __typename?: 'TeamSongFeedback';
  congregationalScoreQuartiles: QuartileData;
  overallScore: Scalars['Float'];
  personalScoreQuartiles: QuartileData;
  setlistTeamSongFeedbackReports: Array<TeamSongFeedbackReport>;
  teamScoreQuartiles: QuartileData;
  teamSongFeedbackReports: Array<TeamSongFeedbackReport>;
  teamSongFeedbackSubmissionIds: Array<Scalars['String']>;
  teamSongFeedbackSubmissions: Array<TeamSongFeedbackSubmission>;
  teamSongId: Scalars['String'];
  trend: Trend;
};

export type TeamSongFeedbackReport = {
  __typename?: 'TeamSongFeedbackReport';
  meanCongregationalScore: Scalars['Float'];
  meanPersonalScore: Scalars['Float'];
  meanTeamScore: Scalars['Float'];
  meanTotalSentimentScore: Scalars['Float'];
  setlistId: Scalars['String'];
  startAt: Scalars['String'];
  teamSongId: Scalars['String'];
};

export type TeamSongFeedbackSubmission = {
  __typename?: 'TeamSongFeedbackSubmission';
  congregationalScore: Scalars['Int'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  personalScore: Scalars['Int'];
  setlistId: Scalars['String'];
  teamScore: Scalars['Int'];
  teamSongId: Scalars['String'];
};

export type TeamSongFeedbackSubmissionInput = {
  congregationalScore: Scalars['Int'];
  personalScore: Scalars['Int'];
  teamScore: Scalars['Int'];
  teamSongId: Scalars['String'];
};

export type TeamSongInput = {
  appleMusicId?: InputMaybe<Scalars['String']>;
  artist: Scalars['String'];
  artworkUrl?: InputMaybe<Scalars['String']>;
  ccli?: InputMaybe<Scalars['Int']>;
  defaultKey?: InputMaybe<Scalars['String']>;
  emotionTags?: InputMaybe<Array<Scalars['String']>>;
  energyTags?: InputMaybe<Array<Scalars['String']>>;
  gospelTags?: InputMaybe<Array<Scalars['String']>>;
  lyrics?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  new?: InputMaybe<Scalars['Boolean']>;
  recommendedKey?: InputMaybe<Scalars['String']>;
  recordedKey?: InputMaybe<Scalars['String']>;
  rotationStatus?: InputMaybe<Scalars['String']>;
  songTypeTags?: InputMaybe<Array<Scalars['String']>>;
  spotifyId?: InputMaybe<Scalars['String']>;
  youtubeId?: InputMaybe<Scalars['String']>;
};

export type TestNotificationsInput = {
  delay?: InputMaybe<Scalars['Int']>;
  message?: InputMaybe<Scalars['String']>;
};

export type ThematicalAnalysisOutputItem = {
  __typename?: 'ThematicalAnalysisOutputItem';
  strength?: Maybe<Scalars['Float']>;
  theme: Scalars['String'];
};

export type ThematicalAnalysisOutputItemInput = {
  strength?: InputMaybe<Scalars['Float']>;
  theme: Scalars['String'];
};

export type TheologicalAnalysisOutputItem = {
  __typename?: 'TheologicalAnalysisOutputItem';
  strength?: Maybe<Scalars['Float']>;
  theology: Scalars['String'];
};

export type TheologicalAnalysisOutputItemInput = {
  strength?: InputMaybe<Scalars['Float']>;
  theology: Scalars['String'];
};

export enum Trend {
  Down = 'DOWN',
  Flat = 'FLAT',
  Up = 'UP'
}

export type User = {
  __typename?: 'User';
  birthYear?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  completedMilestones: Array<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastSeenAt: Scalars['String'];
  notificationId?: Maybe<Scalars['String']>;
  notificationPreferences: NotificationPreferences;
  role?: Maybe<Scalars['String']>;
  skills: Array<Scalars['String']>;
};

export type UserChatStat = {
  __typename?: 'UserChatStat';
  lastSeenAt: Scalars['String'];
  userId: Scalars['String'];
};

export type UserInput = {
  birthYear?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['String']>;
  completedMilestones?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  notificationId?: InputMaybe<Scalars['String']>;
  notificationPreferences?: InputMaybe<NotificationPreferencesInput>;
  pcoId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<Scalars['String']>>;
};

export type UserTopTeamSong = {
  __typename?: 'UserTopTeamSong';
  score: Scalars['Float'];
  teamSong: TeamSong;
};

export type Video = {
  __typename?: 'Video';
  chat?: Maybe<VideoChat>;
  contributor?: Maybe<Contributor>;
  contributorId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  paid: Scalars['Boolean'];
  posterUrl: Scalars['String'];
  stat?: Maybe<VideoStat>;
  thumbnailUrl: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  videoCollection?: Maybe<VideoCollection>;
};

export type VideoChat = {
  __typename?: 'VideoChat';
  id: Scalars['ID'];
  messages?: Maybe<MessageResults>;
  stat?: Maybe<ChatStat>;
  type: Scalars['String'];
  userStats?: Maybe<Array<UserChatStat>>;
  video?: Maybe<Video>;
  videoId: Scalars['String'];
};


export type VideoChatMessagesArgs = {
  input: PaginationInput;
};

export type VideoCollection = {
  __typename?: 'VideoCollection';
  hex: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  onboarding: Scalars['Boolean'];
  paid: Scalars['Boolean'];
  stat?: Maybe<VideoCollectionStat>;
  videoIds: Array<Scalars['String']>;
  videos?: Maybe<Array<Video>>;
};

export type VideoCollectionInput = {
  hex: Scalars['String'];
  name: Scalars['String'];
  onboarding: Scalars['Boolean'];
  paid: Scalars['Boolean'];
  videoIds: Array<Scalars['String']>;
};

export type VideoCollectionStat = {
  __typename?: 'VideoCollectionStat';
  canBeCompleted: Scalars['Boolean'];
  completed: Scalars['Boolean'];
};

export type VideoCollectionStatInput = {
  completed: Scalars['Boolean'];
};

export type VideoInput = {
  contributorId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration: Scalars['Int'];
  name: Scalars['String'];
  paid: Scalars['Boolean'];
  posterUrl: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  url: Scalars['String'];
};

export type VideoStat = {
  __typename?: 'VideoStat';
  fullyWatched: Scalars['Boolean'];
  percentagePlayed: Scalars['Float'];
};

export type VideoStatInput = {
  percentagePlayed: Scalars['Float'];
};

export type WeightedTeamSong = {
  __typename?: 'WeightedTeamSong';
  errors: Array<Scalars['String']>;
  teamSong: TeamSong;
  teamSongId: Scalars['String'];
  weight: Scalars['Float'];
  weights: Scalars['JSON'];
};

export type SendCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type SendCodeMutation = { __typename?: 'Mutation', sendCode: boolean };

export type DeleteMyUserMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type DeleteMyUserMutation = { __typename?: 'Mutation', deleteMyUser: { __typename?: 'User', id: string } };

export type CreateTeamServiceMutationVariables = Exact<{
  input: ServiceInput;
}>;


export type CreateTeamServiceMutation = { __typename?: 'Mutation', createTeamService: { __typename?: 'Service', id: string, name: string, startAt: string, day: number, size?: string | null } };

export type UpdateTeamServiceMutationVariables = Exact<{
  serviceId: Scalars['String'];
  input: ServiceInput;
}>;


export type UpdateTeamServiceMutation = { __typename?: 'Mutation', updateTeamService: { __typename?: 'Service', id: string, name: string, startAt: string, day: number, size?: string | null } };

export type DeleteTeamServiceMutationVariables = Exact<{
  serviceId: Scalars['String'];
}>;


export type DeleteTeamServiceMutation = { __typename?: 'Mutation', deleteTeamService: { __typename?: 'Service', id: string, name: string, startAt: string, day: number } };

export type DemoteUserToTeamMemberMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DemoteUserToTeamMemberMutation = { __typename?: 'Mutation', demoteUserToTeamMember: boolean };

export type PromoteUserToTeamAdminMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type PromoteUserToTeamAdminMutation = { __typename?: 'Mutation', promoteUserToTeamAdmin: boolean };

export type RemoveUserFromTeamMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RemoveUserFromTeamMutation = { __typename?: 'Mutation', removeUserFromTeam: boolean };

export type DeleteInviteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteInviteMutation = { __typename?: 'Mutation', deleteInvite?: { __typename?: 'Invite', id: string, email: string } | null };

export type CreateInviteMutationVariables = Exact<{
  email: Scalars['String'];
  shouldBeAdmin: Scalars['Boolean'];
}>;


export type CreateInviteMutation = { __typename?: 'Mutation', createInvite?: { __typename?: 'Invite', id: string, email: string } | null };

export type ResendInviteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResendInviteMutation = { __typename?: 'Mutation', resendInvite?: { __typename?: 'Invite', id: string, email: string } | null };

export type CreateMessageReactionMutationVariables = Exact<{
  messageId: Scalars['String'];
  emojiCode: Scalars['String'];
}>;


export type CreateMessageReactionMutation = { __typename?: 'Mutation', createMessageReaction: { __typename?: 'Reaction', id: string, userId: string, emojiCode: string } };

export type CreateTeamSongMutationVariables = Exact<{
  input: TeamSongInput;
}>;


export type CreateTeamSongMutation = { __typename?: 'Mutation', createTeamSong: { __typename?: 'TeamSong', id: string, name: string } };

export type SearchSongsMutationVariables = Exact<{
  filters?: InputMaybe<SearchSongsFilters>;
  input: PaginationInput;
  excludeMyTeamSongs?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchSongsMutation = { __typename?: 'Mutation', searchSongs: { __typename?: 'SongResults', count: number, totalCount: number, items: Array<{ __typename?: 'Song', appleMusicId?: string | null, artist: string, artworkUrl?: string | null, id: string, name: string, recommendedKey?: string | null, recordedKey?: string | null, spotifyId?: string | null, youtubeId?: string | null, ccli?: number | null, emotionTags: Array<string>, energyTags: Array<string>, gospelTags: Array<string>, songTypeTags: Array<string>, themeTags: Array<string>, variations: Array<string>, lyrics?: string | null, analysisStatus?: SongAnalyisStatus | null, analyzed: boolean, analysisOutput?: { __typename?: 'FullAnalysisOutput', emotions: Array<{ __typename?: 'EmotionalAnalysisOutputItem', emotion: string, strength?: number | null }>, thematicKeywords: Array<{ __typename?: 'ThematicalAnalysisOutputItem', theme: string, strength?: number | null }>, theologicalKeywords: Array<{ __typename?: 'TheologicalAnalysisOutputItem', theology: string, strength?: number | null }>, gospelStory: Array<{ __typename?: 'GospelStoryItem', tag: string, strength?: number | null }> } | null }> } };

export type AddSongsToMyTeamMutationVariables = Exact<{
  songIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AddSongsToMyTeamMutation = { __typename?: 'Mutation', addSongsToMyTeam: Array<{ __typename?: 'TeamSong', id: string, name: string }> };

export type CreateSetlistMutationVariables = Exact<{
  input: SetlistInput;
}>;


export type CreateSetlistMutation = { __typename?: 'Mutation', createSetlist: { __typename?: 'Setlist', id: string } };

export type UpdateSetlistMutationVariables = Exact<{
  setlistId: Scalars['String'];
  input: SetlistInput;
}>;


export type UpdateSetlistMutation = { __typename?: 'Mutation', updateSetlist: { __typename?: 'Setlist', id: string } };

export type DeleteSetlistMutationVariables = Exact<{
  setlistId: Scalars['String'];
}>;


export type DeleteSetlistMutation = { __typename?: 'Mutation', deleteSetlist: { __typename?: 'Setlist', id: string } };

export type GenerateSetlistMutationVariables = Exact<{
  teamId: Scalars['String'];
  request: GenerateSetlistDefinitionInput;
}>;


export type GenerateSetlistMutation = { __typename?: 'Mutation', generateSetlist: { __typename?: 'GeneratedSetlist', reasoning?: any | null, positions: Array<{ __typename?: 'TeamSong', id: string } | null> } };

export type ClearGenerateSetlistCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearGenerateSetlistCacheMutation = { __typename?: 'Mutation', clearGenerateSetlistCache: boolean };

export type GetBiblePassageAnalysisMutationVariables = Exact<{
  reference: Scalars['String'];
}>;


export type GetBiblePassageAnalysisMutation = { __typename?: 'Mutation', getBiblePassageAnalysis?: { __typename?: 'FullAnalysisOutput', emotions: Array<{ __typename?: 'EmotionalAnalysisOutputItem', emotion: string, strength?: number | null }>, thematicKeywords: Array<{ __typename?: 'ThematicalAnalysisOutputItem', theme: string, strength?: number | null }>, theologicalKeywords: Array<{ __typename?: 'TheologicalAnalysisOutputItem', theology: string, strength?: number | null }> } | null };

export type GetLyricsAndPassageSummaryMutationVariables = Exact<{
  input: LyricsAndPassageSummaryInput;
}>;


export type GetLyricsAndPassageSummaryMutation = { __typename?: 'Mutation', getLyricsAndPassageSummary?: { __typename?: 'LyricsAndPassageSummary', passage: string, lyrics: string, summary: string } | null };

export type ListBibleBooksQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBibleBooksQuery = { __typename?: 'Query', listBibleBooks: Array<{ __typename?: 'BibleBook', name: string, code: string }> };

export type ListBibleChaptersQueryVariables = Exact<{
  bookCode: Scalars['String'];
}>;


export type ListBibleChaptersQuery = { __typename?: 'Query', listBibleChapters: Array<{ __typename?: 'BibleChapter', id: number, bibleBookCode: string, number: number }> };

export type ListBibleVersesQueryVariables = Exact<{
  chapterId: Scalars['Int'];
}>;


export type ListBibleVersesQuery = { __typename?: 'Query', listBibleVerses: Array<{ __typename?: 'BibleVerse', reference: string, content: string, number: number }> };

export type GetSetlistSummaryMutationVariables = Exact<{
  teamSongIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetSetlistSummaryMutation = { __typename?: 'Mutation', getSetlistSummary?: { __typename?: 'SetlistSummary', summary: string, themes: string, theology: string, gospel_story: string, emotions: string, energy: string, recommendations: string } | null };

export type GetSongSummaryMutationVariables = Exact<{
  teamSongId: Scalars['String'];
}>;


export type GetSongSummaryMutation = { __typename?: 'Mutation', getSongSummary?: { __typename?: 'SongSummary', summary: string, themes: string, theology: string, gospel_story: string, emotions: string } | null };

export type RequestSongImportUploadMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestSongImportUploadMutation = { __typename?: 'Mutation', requestSongImportUpload: { __typename?: 'SongImportUpload', key: string, uploadUrl: string } };

export type ReadSongsImportUploadMutationVariables = Exact<{
  uploadKey: Scalars['String'];
}>;


export type ReadSongsImportUploadMutation = { __typename?: 'Mutation', readSongsImportUpload: { __typename?: 'SongImportColumns', columns: Array<string>, rowCount: number } };

export type VerifySongsImportUploadMutationVariables = Exact<{
  uploadKey: Scalars['String'];
  settings?: InputMaybe<SongImportSettingsInput>;
}>;


export type VerifySongsImportUploadMutation = { __typename?: 'Mutation', verifySongsImportUpload: { __typename?: 'SongImport', uploadKey: string, phase: string, createdSongs: number, matchedSongs: number, totalSongs: number, progress: number, error?: string | null, createdAt: string, completedAt?: string | null, cancelledAt?: string | null } };

export type ProcessSongsImportUploadMutationVariables = Exact<{
  uploadKey: Scalars['String'];
  settings?: InputMaybe<SongImportSettingsInput>;
}>;


export type ProcessSongsImportUploadMutation = { __typename?: 'Mutation', processSongsImportUpload: { __typename?: 'SongImport', uploadKey: string, phase: string, createdSongs: number, matchedSongs: number, totalSongs: number, progress: number, error?: string | null, createdAt: string, completedAt?: string | null, cancelledAt?: string | null } };

export type CancelSongsImportUploadMutationVariables = Exact<{
  uploadKey: Scalars['String'];
}>;


export type CancelSongsImportUploadMutation = { __typename?: 'Mutation', cancelSongsImportUpload: { __typename?: 'SongImport', uploadKey: string, phase: string, createdSongs: number, matchedSongs: number, totalSongs: number, progress: number, error?: string | null, createdAt: string, completedAt?: string | null, cancelledAt?: string | null } };

export type GetSongsImportQueryVariables = Exact<{
  uploadKey: Scalars['String'];
}>;


export type GetSongsImportQuery = { __typename?: 'Query', getSongsImport: { __typename?: 'SongImport', uploadKey: string, phase: string, createdSongs: number, matchedSongs: number, totalSongs: number, progress: number, error?: string | null, createdAt: string, completedAt?: string | null, cancelledAt?: string | null, report?: { __typename?: 'SongImportReport', totalSongs: number, matchedSongIds: Array<string>, existingOnTeam: Array<string>, newSongs: Array<string>, missingLyrics: Array<string>, sample: Array<{ __typename?: 'SongImportRowPreview', title: string, artist: string, defaultKey?: string | null, artworkUrl?: string | null }> } | null } };

export type GetSongColletionMutationVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetSongColletionMutation = { __typename?: 'Mutation', getSongCollection: { __typename?: 'SongCollection', songIds: Array<string> } };

export type GetTeamSongMutationVariables = Exact<{
  teamSongId: Scalars['String'];
}>;


export type GetTeamSongMutation = { __typename?: 'Mutation', getTeamSong: { __typename?: 'TeamSong', appleMusicId?: string | null, artist: string, artworkUrl?: string | null, id: string, name: string, recommendedKey?: string | null, recordedKey?: string | null, defaultKey?: string | null, spotifyId?: string | null, youtubeId?: string | null, originSongId?: string | null, ccli?: number | null, emotionTags: Array<string>, energyTags: Array<string>, gospelTags: Array<string>, themeTags: Array<string>, songTypeTags: Array<string>, rotationStatus?: string | null, lyrics?: string | null, new: boolean, analysisStatus?: SongAnalyisStatus | null, feedback?: { __typename?: 'TeamSongFeedback', overallScore: number, trend: Trend, teamSongFeedbackReports: Array<{ __typename?: 'TeamSongFeedbackReport', setlistId: string, teamSongId: string, meanPersonalScore: number, meanTeamScore: number, meanCongregationalScore: number, meanTotalSentimentScore: number, startAt: string }>, personalScoreQuartiles: { __typename?: 'QuartileData', q1: number, q2: number, q3: number }, teamScoreQuartiles: { __typename?: 'QuartileData', q1: number, q2: number, q3: number }, congregationalScoreQuartiles: { __typename?: 'QuartileData', q1: number, q2: number, q3: number } } | null, setlists?: Array<{ __typename?: 'Setlist', id: string, startAt: string }> | null, analysisOutput?: { __typename?: 'FullAnalysisOutput', summary?: string | null, emotions: Array<{ __typename?: 'EmotionalAnalysisOutputItem', emotion: string, strength?: number | null }>, thematicKeywords: Array<{ __typename?: 'ThematicalAnalysisOutputItem', theme: string, strength?: number | null }>, theologicalKeywords: Array<{ __typename?: 'TheologicalAnalysisOutputItem', theology: string, strength?: number | null }>, gospelStory: Array<{ __typename?: 'GospelStoryItem', tag: string, strength?: number | null }> } | null } };

export type ReanalyzeSongMutationVariables = Exact<{
  songId: Scalars['String'];
}>;


export type ReanalyzeSongMutation = { __typename?: 'Mutation', reanalyzeSong: { __typename?: 'Song', id: string, analysisStatus?: SongAnalyisStatus | null, analysisOutput?: { __typename?: 'FullAnalysisOutput', summary?: string | null, emotions: Array<{ __typename?: 'EmotionalAnalysisOutputItem', emotion: string, strength?: number | null }>, thematicKeywords: Array<{ __typename?: 'ThematicalAnalysisOutputItem', theme: string, strength?: number | null }>, theologicalKeywords: Array<{ __typename?: 'TheologicalAnalysisOutputItem', theology: string, strength?: number | null }>, gospelStory: Array<{ __typename?: 'GospelStoryItem', tag: string, strength?: number | null }> } | null } };

export type GetSongMutationVariables = Exact<{
  songId: Scalars['String'];
}>;


export type GetSongMutation = { __typename?: 'Mutation', getSong: { __typename?: 'Song', appleMusicId?: string | null, artist: string, artworkUrl?: string | null, id: string, name: string, recommendedKey?: string | null, recordedKey?: string | null, spotifyId?: string | null, youtubeId?: string | null, ccli?: number | null, emotionTags: Array<string>, energyTags: Array<string>, gospelTags: Array<string>, songTypeTags: Array<string>, themeTags: Array<string>, variations: Array<string>, lyrics?: string | null, analysisStatus?: SongAnalyisStatus | null, analyzed: boolean, analysisOutput?: { __typename?: 'FullAnalysisOutput', summary?: string | null, emotions: Array<{ __typename?: 'EmotionalAnalysisOutputItem', emotion: string, strength?: number | null }>, thematicKeywords: Array<{ __typename?: 'ThematicalAnalysisOutputItem', theme: string, strength?: number | null }>, theologicalKeywords: Array<{ __typename?: 'TheologicalAnalysisOutputItem', theology: string, strength?: number | null }>, gospelStory: Array<{ __typename?: 'GospelStoryItem', tag: string, strength?: number | null }> } | null } };

export type CreateChatMutationVariables = Exact<{
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateChatMutation = { __typename?: 'Mutation', upsertChat: { __typename?: 'Chat', id: string } };

export type SendChatMessageMutationVariables = Exact<{
  chatId: Scalars['String'];
  input: MessageInput;
}>;


export type SendChatMessageMutation = { __typename?: 'Mutation', sendChatMessage: boolean };

export type GetUserTopTeamSongsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserTopTeamSongsQuery = { __typename?: 'Query', getUserTopTeamSongs?: Array<{ __typename?: 'UserTopTeamSong', score: number, teamSong: { __typename?: 'TeamSong', id: string, name: string, artist: string, artworkUrl?: string | null, recordedKey?: string | null, recommendedKey?: string | null, defaultKey?: string | null, rotationStatus?: string | null, analysisStatus?: SongAnalyisStatus | null } }> | null };

export type UpsertVideoCollectionStatMutationVariables = Exact<{
  videoCollectionId: Scalars['String'];
  input: VideoCollectionStatInput;
}>;


export type UpsertVideoCollectionStatMutation = { __typename?: 'Mutation', upsertVideoCollectionStat: boolean };

export type GetChatQueryVariables = Exact<{
  chatId: Scalars['String'];
  input: PaginationInput;
}>;


export type GetChatQuery = { __typename?: 'Query', getChat: { __typename?: 'Chat', type: string, id: string, createdAt: string, userIds: Array<string>, name?: string | null, users?: Array<{ __typename?: 'User', id: string, email: string, displayName?: string | null }> | null, userStats?: Array<{ __typename?: 'UserChatStat', userId: string, lastSeenAt: string }> | null, messages?: { __typename?: 'MessageResults', count: number, totalCount: number, items: Array<{ __typename?: 'Message', type: MessageType, metadata?: string | null, content: string, createdAt: string, id: string, userId: string, user?: { __typename?: 'User', displayName?: string | null, id: string } | null, reactions: Array<{ __typename?: 'Reaction', id: string, emojiCode: string, userId: string, messageId: string, createdAt: string }> }> } | null } };

export type GetChatUserStatsQueryVariables = Exact<{
  chatId: Scalars['String'];
}>;


export type GetChatUserStatsQuery = { __typename?: 'Query', getChat: { __typename?: 'Chat', id: string, userStats?: Array<{ __typename?: 'UserChatStat', userId: string, lastSeenAt: string }> | null } };

export type FetchChatMessagesMutationVariables = Exact<{
  chatId: Scalars['String'];
  input: PaginationInput;
}>;


export type FetchChatMessagesMutation = { __typename?: 'Mutation', getChat: { __typename?: 'Chat', id: string, messages?: { __typename?: 'MessageResults', totalCount: number, items: Array<{ __typename?: 'Message', type: MessageType, metadata?: string | null, content: string, createdAt: string, id: string, userId: string, user?: { __typename?: 'User', displayName?: string | null, id: string } | null, reactions: Array<{ __typename?: 'Reaction', id: string, emojiCode: string, userId: string, messageId: string, createdAt: string }> }> } | null } };

export type FetchChatReactionsMutationVariables = Exact<{
  chatId: Scalars['String'];
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
}>;


export type FetchChatReactionsMutation = { __typename?: 'Mutation', getChatReactions: Array<{ __typename?: 'Reaction', id: string, emojiCode: string, userId: string, messageId: string, createdAt: string }> };

export type FetchMessageReactionsMutationVariables = Exact<{
  messageId: Scalars['String'];
}>;


export type FetchMessageReactionsMutation = { __typename?: 'Mutation', getMessageReactions: Array<{ __typename?: 'Reaction', id: string, emojiCode: string, userId: string, messageId: string, createdAt: string }> };

export type UpdateChatMutationVariables = Exact<{
  chatId: Scalars['String'];
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateChatMutation = { __typename?: 'Mutation', updateChat: { __typename?: 'Chat', id: string } };

export type RenameChatMutationVariables = Exact<{
  chatId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type RenameChatMutation = { __typename?: 'Mutation', renameChat: { __typename?: 'Chat', id: string } };

export type LeaveChatMutationVariables = Exact<{
  chatId: Scalars['String'];
}>;


export type LeaveChatMutation = { __typename?: 'Mutation', leaveChat: { __typename?: 'Chat', id: string } };

export type UpsertChatStatMutationVariables = Exact<{
  chatId: Scalars['String'];
}>;


export type UpsertChatStatMutation = { __typename?: 'Mutation', upsertChatStat: { __typename?: 'ChatStat', lastSeenAt: string } };

export type SendChatTypingStatusMutationVariables = Exact<{
  chatId: Scalars['String'];
}>;


export type SendChatTypingStatusMutation = { __typename?: 'Mutation', sendChatTypingStatus: boolean };

export type GetDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardQuery = { __typename?: 'Query', getDashboard: { __typename?: 'Dashboard', videoCollections?: Array<{ __typename?: 'VideoCollection', id: string, name: string, paid: boolean, onboarding: boolean, hex: string, stat?: { __typename?: 'VideoCollectionStat', canBeCompleted: boolean, completed: boolean } | null, videos?: Array<{ __typename?: 'Video', description: string, duration: number, id: string, name: string, paid: boolean, thumbnailUrl: string, url?: string | null, stat?: { __typename?: 'VideoStat', fullyWatched: boolean, percentagePlayed: number } | null, contributor?: { __typename?: 'Contributor', name: string, imageUrl?: string | null } | null, chat?: { __typename?: 'VideoChat', id: string } | null }> | null }> | null } };

export type TestNotificationMutationVariables = Exact<{
  input?: InputMaybe<TestNotificationsInput>;
}>;


export type TestNotificationMutation = { __typename?: 'Mutation', testNotifications?: boolean | null };

export type ListMySetlistFeedbackRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMySetlistFeedbackRequestsQuery = { __typename?: 'Query', listMySetlistFeedbackRequests: Array<{ __typename?: 'Setlist', id: string }> };

export type CreateSetlistFeedbackSubmissionMutationVariables = Exact<{
  input: SetlistFeedbackSubmissionInput;
}>;


export type CreateSetlistFeedbackSubmissionMutation = { __typename?: 'Mutation', createSetlistFeedbackSubmission: { __typename?: 'SetlistFeedbackSubmission', id: string, teamSongFeedbackSubmissionIds: Array<string>, teamSongFeedbackSubmissions: Array<{ __typename?: 'TeamSongFeedbackSubmission', id: string }> } };

export type ListMyChatsQueryVariables = Exact<{
  input: PaginationInput;
}>;


export type ListMyChatsQuery = { __typename?: 'Query', listMyChats: Array<{ __typename?: 'Chat', id: string, createdAt: string, type: string, userIds: Array<string>, name?: string | null, users?: Array<{ __typename?: 'User', id: string, displayName?: string | null }> | null, messages?: { __typename?: 'MessageResults', items: Array<{ __typename?: 'Message', createdAt: string, userId: string, content: string, user?: { __typename?: 'User', id: string, displayName?: string | null } | null }> } | null }> };

export type ListTeamVideoChatsQueryVariables = Exact<{
  input: PaginationInput;
}>;


export type ListTeamVideoChatsQuery = { __typename?: 'Query', listTeamVideoChats: Array<{ __typename?: 'VideoChat', id: string, messages?: { __typename?: 'MessageResults', items: Array<{ __typename?: 'Message', createdAt: string, content: string, user?: { __typename?: 'User', displayName?: string | null } | null }> } | null, video?: { __typename?: 'Video', id: string, name: string, thumbnailUrl: string } | null }> };

export type GetDashboardOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardOnboardingQuery = { __typename?: 'Query', getDashboard: { __typename?: 'Dashboard', videoCollections?: Array<{ __typename?: 'VideoCollection', id: string, onboarding: boolean, videos?: Array<{ __typename?: 'Video', id: string }> | null }> | null } };

export type GetReelFeedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReelFeedQuery = { __typename?: 'Query', getReelFeed: Array<{ __typename?: 'Reel', id: string, name: string, url: string, posterUrl: string, videoId: string, stat?: { __typename?: 'ReelStat', liked: boolean } | null, video?: { __typename?: 'Video', name: string, description: string, contributor?: { __typename?: 'Contributor', name: string, imageUrl?: string | null } | null, videoCollection?: { __typename?: 'VideoCollection', name: string, hex: string } | null } | null }> };

export type UpsertReelStatMutationVariables = Exact<{
  reelId: Scalars['String'];
  input: ReelStatInput;
}>;


export type UpsertReelStatMutation = { __typename?: 'Mutation', upsertReelStat: { __typename?: 'ReelStat', liked: boolean } };

export type ListMyTeamSetlistsForReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMyTeamSetlistsForReportsQuery = { __typename?: 'Query', listMyTeamSetlists: Array<{ __typename?: 'Setlist', id: string, serviceId?: string | null, startAt: string, draft: boolean, teamSongIds: Array<string>, feedback?: { __typename?: 'SetlistFeedback', submissions: Array<{ __typename?: 'SetlistFeedbackSubmission', userId: string, teamSongFeedbackSubmissions: Array<{ __typename?: 'TeamSongFeedbackSubmission', teamSongId: string, personalScore: number, teamScore: number, congregationalScore: number }> }> } | null }> };

export type UpdateTeamSongMutationVariables = Exact<{
  teamSongId: Scalars['String'];
  input: TeamSongInput;
}>;


export type UpdateTeamSongMutation = { __typename?: 'Mutation', updateTeamSong: { __typename?: 'TeamSong', appleMusicId?: string | null, artist: string, artworkUrl?: string | null, id: string, name: string, recommendedKey?: string | null, recordedKey?: string | null, defaultKey?: string | null, spotifyId?: string | null, youtubeId?: string | null, originSongId?: string | null, ccli?: number | null, emotionTags: Array<string>, energyTags: Array<string>, gospelTags: Array<string>, songTypeTags: Array<string>, rotationStatus?: string | null, lyrics?: string | null, new: boolean } };

export type DeleteTeamSongMutationVariables = Exact<{
  teamSongId: Scalars['String'];
}>;


export type DeleteTeamSongMutation = { __typename?: 'Mutation', deleteTeamSong: { __typename?: 'TeamSong', id: string, name: string } };

export type GetVideoQueryVariables = Exact<{
  getVideoId: Scalars['String'];
  input: PaginationInput;
}>;


export type GetVideoQuery = { __typename?: 'Query', getVideo: { __typename?: 'Video', description: string, duration: number, id: string, name: string, paid: boolean, posterUrl: string, thumbnailUrl: string, url?: string | null, contributor?: { __typename?: 'Contributor', imageUrl?: string | null, description: string, role: string, id: string, name: string, videoIds: Array<string> } | null, stat?: { __typename?: 'VideoStat', fullyWatched: boolean, percentagePlayed: number } | null, chat?: { __typename?: 'VideoChat', id: string, type: string, userStats?: Array<{ __typename?: 'UserChatStat', userId: string, lastSeenAt: string }> | null, messages?: { __typename?: 'MessageResults', totalCount: number, items: Array<{ __typename?: 'Message', type: MessageType, metadata?: string | null, content: string, createdAt: string, id: string, userId: string, user?: { __typename?: 'User', displayName?: string | null, id: string } | null, reactions: Array<{ __typename?: 'Reaction', id: string, emojiCode: string, userId: string, messageId: string, createdAt: string }> }> } | null } | null, videoCollection?: { __typename?: 'VideoCollection', id: string, name: string, onboarding: boolean, videoIds: Array<string>, videos?: Array<{ __typename?: 'Video', id: string, name: string, paid: boolean, description: string, duration: number, posterUrl: string, thumbnailUrl: string, url?: string | null }> | null } | null } };

export type FetchVideoChatMessagesMutationVariables = Exact<{
  videoId: Scalars['String'];
  input: PaginationInput;
}>;


export type FetchVideoChatMessagesMutation = { __typename?: 'Mutation', getVideoChat: { __typename?: 'VideoChat', id: string, type: string, userStats?: Array<{ __typename?: 'UserChatStat', userId: string, lastSeenAt: string }> | null, messages?: { __typename?: 'MessageResults', totalCount: number, items: Array<{ __typename?: 'Message', type: MessageType, metadata?: string | null, content: string, createdAt: string, id: string, userId: string, user?: { __typename?: 'User', displayName?: string | null, id: string } | null, reactions: Array<{ __typename?: 'Reaction', id: string, emojiCode: string, userId: string, messageId: string, createdAt: string }> }> } | null } };

export type SendVideoChatMessageMutationVariables = Exact<{
  videoId: Scalars['String'];
  input: MessageInput;
}>;


export type SendVideoChatMessageMutation = { __typename?: 'Mutation', sendVideoChatMessage: boolean };

export type UpsertVideoStatMutationVariables = Exact<{
  videoId: Scalars['String'];
  input: VideoStatInput;
}>;


export type UpsertVideoStatMutation = { __typename?: 'Mutation', upsertVideoStat: { __typename?: 'VideoStat', percentagePlayed: number } };

export type UpdateLastSeenAtMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateLastSeenAtMutation = { __typename?: 'Mutation', updateLastSeenAt: { __typename?: 'User', lastSeenAt: string } };

export type GetMyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyUserQuery = { __typename?: 'Query', getMyUser: { __typename?: 'User', id: string, displayName?: string | null, email: string, notificationId?: string | null, lastSeenAt: string, gender?: string | null, birthYear?: number | null, color?: string | null, role?: string | null, skills: Array<string>, completedMilestones: Array<string>, notificationPreferences: { __typename?: 'NotificationPreferences', chat: boolean, videoChat: boolean, videoChatActiveOnly: boolean, groupChat: boolean, reEngagementNudge: boolean } } };

export type UpdateMyUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type UpdateMyUserMutation = { __typename?: 'Mutation', updateMyUser: { __typename?: 'User', id: string, displayName?: string | null, email: string, notificationId?: string | null, lastSeenAt: string, gender?: string | null, birthYear?: number | null, color?: string | null, role?: string | null, skills: Array<string>, completedMilestones: Array<string>, notificationPreferences: { __typename?: 'NotificationPreferences', chat: boolean, videoChat: boolean, videoChatActiveOnly: boolean, groupChat: boolean, reEngagementNudge: boolean } } };

export type GetMyPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPermissionsQuery = { __typename?: 'Query', getMyPermissions: Array<string> };

export type ListTeamServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTeamServiceQuery = { __typename?: 'Query', listTeamServices: Array<{ __typename?: 'Service', id: string, name: string, startAt: string, day: number, size?: string | null }> };

export type ListMyTeamSetlistsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMyTeamSetlistsQuery = { __typename?: 'Query', listMyTeamSetlists: Array<{ __typename?: 'Setlist', id: string, userId: string, serviceId?: string | null, startAt: string, teamSongIds: Array<string>, createdAt: string, draft: boolean, feedback?: { __typename?: 'SetlistFeedback', overallScore: number, personalScoreQuartiles: { __typename?: 'QuartileData', q1: number, q2: number, q3: number }, teamScoreQuartiles: { __typename?: 'QuartileData', q1: number, q2: number, q3: number }, congregationalScoreQuartiles: { __typename?: 'QuartileData', q1: number, q2: number, q3: number }, teamSongFeedbackReports: Array<{ __typename?: 'TeamSongFeedbackReport', teamSongId: string, setlistId: string, meanPersonalScore: number, meanTeamScore: number, meanCongregationalScore: number, meanTotalSentimentScore: number }>, submissions: Array<{ __typename?: 'SetlistFeedbackSubmission', userId: string, teamSongFeedbackSubmissionIds: Array<string> }> } | null, submissions?: Array<{ __typename?: 'SetlistFeedbackSubmission', userId: string, teamSongFeedbackSubmissionIds: Array<string> }> | null, teamSongOverrides: Array<{ __typename?: 'SetlistTeamSong', id: string, defaultKey?: string | null }>, generateSettings?: { __typename?: 'GenerateSetlistSettings', totalSongPositions?: number | null, postSermonSongPosition?: number | null, searchTerm?: string | null, bibleVerseReference?: string | null, bibleReference?: string | null } | null }> };

export type GetSubscriptionSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionSessionMutation = { __typename?: 'Mutation', getChargebeePortalSession?: string | null };

export type LinkTeamChargebeeCustomerMutationVariables = Exact<{ [key: string]: never; }>;


export type LinkTeamChargebeeCustomerMutation = { __typename?: 'Mutation', linkTeamChargebeeCustomer: boolean };

export type IsChargebeeCouponUsableQueryVariables = Exact<{
  couponId: Scalars['String'];
}>;


export type IsChargebeeCouponUsableQuery = { __typename?: 'Query', isChargebeeCouponUsable: boolean };

export type CheckSubscriptionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckSubscriptionStatusQuery = { __typename?: 'Query', checkAndSetChargebeeSubscription: boolean };

export type TeamActionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type TeamActionSubscription = { __typename?: 'Subscription', teamAction?: { __typename?: 'TeamAction', action: TeamActionActions, resourceIds: Array<string>, actorId: string } | null };

export type GetMyTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyTeamQuery = { __typename?: 'Query', getMyTeam: { __typename?: 'Team', id: string, name: string, subscriptionStatus: boolean, inviteLinkCode: string, country?: string | null, city?: string | null, denomination?: string | null, chartRepositoryUrl?: string | null, invites?: Array<{ __typename?: 'Invite', id: string, email: string } | null> | null, members: Array<{ __typename?: 'Membership', roles: Array<string>, user: { __typename?: 'User', id: string, displayName?: string | null, email: string, lastSeenAt: string, color?: string | null, skills: Array<string>, birthYear?: number | null, role?: string | null, gender?: string | null } }> } };

export type UpdateMyTeamMutationVariables = Exact<{
  input: TeamInput;
}>;


export type UpdateMyTeamMutation = { __typename?: 'Mutation', updateMyTeam?: { __typename?: 'Team', name: string, chartRepositoryUrl?: string | null } | null };

export type ListTeamSongsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTeamSongsQuery = { __typename?: 'Query', listMyTeamSongs: Array<{ __typename?: 'TeamSong', artist: string, artworkUrl?: string | null, id: string, name: string, recommendedKey?: string | null, recordedKey?: string | null, defaultKey?: string | null, originSongId?: string | null, ccli?: number | null, emotionTags: Array<string>, energyTags: Array<string>, gospelTags: Array<string>, themeTags: Array<string>, songTypeTags: Array<string>, rotationStatus?: string | null, lyrics?: string | null, new: boolean, analysisStatus?: SongAnalyisStatus | null, feedback?: { __typename?: 'TeamSongFeedback', overallScore: number, trend: Trend, teamSongFeedbackReports: Array<{ __typename?: 'TeamSongFeedbackReport', startAt: string, meanPersonalScore: number, meanTeamScore: number, meanCongregationalScore: number }> } | null, setlists?: Array<{ __typename?: 'Setlist', id: string, startAt: string }> | null, analysisOutput?: { __typename?: 'FullAnalysisOutput', emotions: Array<{ __typename?: 'EmotionalAnalysisOutputItem', emotion: string, strength?: number | null }>, thematicKeywords: Array<{ __typename?: 'ThematicalAnalysisOutputItem', theme: string, strength?: number | null }>, theologicalKeywords: Array<{ __typename?: 'TheologicalAnalysisOutputItem', theology: string, strength?: number | null }>, gospelStory: Array<{ __typename?: 'GospelStoryItem', tag: string, strength?: number | null }> } | null }> };

export type ListMyUnreadChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMyUnreadChatsQuery = { __typename?: 'Query', listMyChats: Array<{ __typename?: 'Chat', id: string }> };

export type ListTeamUnreadVideoChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTeamUnreadVideoChatsQuery = { __typename?: 'Query', listTeamVideoChats: Array<{ __typename?: 'VideoChat', id: string }> };


export const SendCodeDocument = `
    mutation SendCode {
  sendCode
}
    `;
export const useSendCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendCodeMutation, TError, SendCodeMutationVariables, TContext>) =>
    useMutation<SendCodeMutation, TError, SendCodeMutationVariables, TContext>(
      ['SendCode'],
      useFetchData<SendCodeMutation, SendCodeMutationVariables>(SendCodeDocument),
      options
    );
export const DeleteMyUserDocument = `
    mutation DeleteMyUser($code: String!) {
  deleteMyUser(code: $code) {
    id
  }
}
    `;
export const useDeleteMyUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMyUserMutation, TError, DeleteMyUserMutationVariables, TContext>) =>
    useMutation<DeleteMyUserMutation, TError, DeleteMyUserMutationVariables, TContext>(
      ['DeleteMyUser'],
      useFetchData<DeleteMyUserMutation, DeleteMyUserMutationVariables>(DeleteMyUserDocument),
      options
    );
export const CreateTeamServiceDocument = `
    mutation CreateTeamService($input: ServiceInput!) {
  createTeamService(input: $input) {
    id
    name
    startAt
    day
    size
  }
}
    `;
export const useCreateTeamServiceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTeamServiceMutation, TError, CreateTeamServiceMutationVariables, TContext>) =>
    useMutation<CreateTeamServiceMutation, TError, CreateTeamServiceMutationVariables, TContext>(
      ['CreateTeamService'],
      useFetchData<CreateTeamServiceMutation, CreateTeamServiceMutationVariables>(CreateTeamServiceDocument),
      options
    );
export const UpdateTeamServiceDocument = `
    mutation UpdateTeamService($serviceId: String!, $input: ServiceInput!) {
  updateTeamService(serviceId: $serviceId, input: $input) {
    id
    name
    startAt
    day
    size
  }
}
    `;
export const useUpdateTeamServiceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTeamServiceMutation, TError, UpdateTeamServiceMutationVariables, TContext>) =>
    useMutation<UpdateTeamServiceMutation, TError, UpdateTeamServiceMutationVariables, TContext>(
      ['UpdateTeamService'],
      useFetchData<UpdateTeamServiceMutation, UpdateTeamServiceMutationVariables>(UpdateTeamServiceDocument),
      options
    );
export const DeleteTeamServiceDocument = `
    mutation DeleteTeamService($serviceId: String!) {
  deleteTeamService(serviceId: $serviceId) {
    id
    name
    startAt
    day
  }
}
    `;
export const useDeleteTeamServiceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTeamServiceMutation, TError, DeleteTeamServiceMutationVariables, TContext>) =>
    useMutation<DeleteTeamServiceMutation, TError, DeleteTeamServiceMutationVariables, TContext>(
      ['DeleteTeamService'],
      useFetchData<DeleteTeamServiceMutation, DeleteTeamServiceMutationVariables>(DeleteTeamServiceDocument),
      options
    );
export const DemoteUserToTeamMemberDocument = `
    mutation DemoteUserToTeamMember($userId: String!) {
  demoteUserToTeamMember(userId: $userId)
}
    `;
export const useDemoteUserToTeamMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DemoteUserToTeamMemberMutation, TError, DemoteUserToTeamMemberMutationVariables, TContext>) =>
    useMutation<DemoteUserToTeamMemberMutation, TError, DemoteUserToTeamMemberMutationVariables, TContext>(
      ['DemoteUserToTeamMember'],
      useFetchData<DemoteUserToTeamMemberMutation, DemoteUserToTeamMemberMutationVariables>(DemoteUserToTeamMemberDocument),
      options
    );
export const PromoteUserToTeamAdminDocument = `
    mutation PromoteUserToTeamAdmin($userId: String!) {
  promoteUserToTeamAdmin(userId: $userId)
}
    `;
export const usePromoteUserToTeamAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PromoteUserToTeamAdminMutation, TError, PromoteUserToTeamAdminMutationVariables, TContext>) =>
    useMutation<PromoteUserToTeamAdminMutation, TError, PromoteUserToTeamAdminMutationVariables, TContext>(
      ['PromoteUserToTeamAdmin'],
      useFetchData<PromoteUserToTeamAdminMutation, PromoteUserToTeamAdminMutationVariables>(PromoteUserToTeamAdminDocument),
      options
    );
export const RemoveUserFromTeamDocument = `
    mutation RemoveUserFromTeam($userId: String!) {
  removeUserFromTeam(userId: $userId)
}
    `;
export const useRemoveUserFromTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveUserFromTeamMutation, TError, RemoveUserFromTeamMutationVariables, TContext>) =>
    useMutation<RemoveUserFromTeamMutation, TError, RemoveUserFromTeamMutationVariables, TContext>(
      ['RemoveUserFromTeam'],
      useFetchData<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>(RemoveUserFromTeamDocument),
      options
    );
export const DeleteInviteDocument = `
    mutation deleteInvite($id: String!) {
  deleteInvite(id: $id) {
    id
    email
  }
}
    `;
export const useDeleteInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteInviteMutation, TError, DeleteInviteMutationVariables, TContext>) =>
    useMutation<DeleteInviteMutation, TError, DeleteInviteMutationVariables, TContext>(
      ['deleteInvite'],
      useFetchData<DeleteInviteMutation, DeleteInviteMutationVariables>(DeleteInviteDocument),
      options
    );
export const CreateInviteDocument = `
    mutation createInvite($email: String!, $shouldBeAdmin: Boolean!) {
  createInvite(email: $email, shouldBeAdmin: $shouldBeAdmin) {
    id
    email
  }
}
    `;
export const useCreateInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateInviteMutation, TError, CreateInviteMutationVariables, TContext>) =>
    useMutation<CreateInviteMutation, TError, CreateInviteMutationVariables, TContext>(
      ['createInvite'],
      useFetchData<CreateInviteMutation, CreateInviteMutationVariables>(CreateInviteDocument),
      options
    );
export const ResendInviteDocument = `
    mutation resendInvite($id: String!) {
  resendInvite(id: $id) {
    id
    email
  }
}
    `;
export const useResendInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResendInviteMutation, TError, ResendInviteMutationVariables, TContext>) =>
    useMutation<ResendInviteMutation, TError, ResendInviteMutationVariables, TContext>(
      ['resendInvite'],
      useFetchData<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument),
      options
    );
export const CreateMessageReactionDocument = `
    mutation createMessageReaction($messageId: String!, $emojiCode: String!) {
  createMessageReaction(messageId: $messageId, emojiCode: $emojiCode) {
    id
    userId
    emojiCode
  }
}
    `;
export const useCreateMessageReactionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMessageReactionMutation, TError, CreateMessageReactionMutationVariables, TContext>) =>
    useMutation<CreateMessageReactionMutation, TError, CreateMessageReactionMutationVariables, TContext>(
      ['createMessageReaction'],
      useFetchData<CreateMessageReactionMutation, CreateMessageReactionMutationVariables>(CreateMessageReactionDocument),
      options
    );
export const CreateTeamSongDocument = `
    mutation CreateTeamSong($input: TeamSongInput!) {
  createTeamSong(input: $input) {
    id
    name
  }
}
    `;
export const useCreateTeamSongMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTeamSongMutation, TError, CreateTeamSongMutationVariables, TContext>) =>
    useMutation<CreateTeamSongMutation, TError, CreateTeamSongMutationVariables, TContext>(
      ['CreateTeamSong'],
      useFetchData<CreateTeamSongMutation, CreateTeamSongMutationVariables>(CreateTeamSongDocument),
      options
    );
export const SearchSongsDocument = `
    mutation SearchSongs($filters: SearchSongsFilters, $input: PaginationInput!, $excludeMyTeamSongs: Boolean) {
  searchSongs(
    filters: $filters
    input: $input
    excludeMyTeamSongs: $excludeMyTeamSongs
  ) {
    count
    items {
      appleMusicId
      artist
      artworkUrl
      id
      name
      recommendedKey
      recordedKey
      spotifyId
      youtubeId
      ccli
      emotionTags
      energyTags
      gospelTags
      songTypeTags
      themeTags
      variations
      lyrics
      analysisOutput {
        emotions {
          emotion
          strength
        }
        thematicKeywords {
          theme
          strength
        }
        theologicalKeywords {
          theology
          strength
        }
        gospelStory {
          tag
          strength
        }
      }
      analysisStatus
      analyzed
    }
    totalCount
  }
}
    `;
export const useSearchSongsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SearchSongsMutation, TError, SearchSongsMutationVariables, TContext>) =>
    useMutation<SearchSongsMutation, TError, SearchSongsMutationVariables, TContext>(
      ['SearchSongs'],
      useFetchData<SearchSongsMutation, SearchSongsMutationVariables>(SearchSongsDocument),
      options
    );
export const AddSongsToMyTeamDocument = `
    mutation AddSongsToMyTeam($songIds: [String!]!) {
  addSongsToMyTeam(songIds: $songIds) {
    id
    name
  }
}
    `;
export const useAddSongsToMyTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSongsToMyTeamMutation, TError, AddSongsToMyTeamMutationVariables, TContext>) =>
    useMutation<AddSongsToMyTeamMutation, TError, AddSongsToMyTeamMutationVariables, TContext>(
      ['AddSongsToMyTeam'],
      useFetchData<AddSongsToMyTeamMutation, AddSongsToMyTeamMutationVariables>(AddSongsToMyTeamDocument),
      options
    );
export const CreateSetlistDocument = `
    mutation CreateSetlist($input: SetlistInput!) {
  createSetlist(input: $input) {
    id
  }
}
    `;
export const useCreateSetlistMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSetlistMutation, TError, CreateSetlistMutationVariables, TContext>) =>
    useMutation<CreateSetlistMutation, TError, CreateSetlistMutationVariables, TContext>(
      ['CreateSetlist'],
      useFetchData<CreateSetlistMutation, CreateSetlistMutationVariables>(CreateSetlistDocument),
      options
    );
export const UpdateSetlistDocument = `
    mutation UpdateSetlist($setlistId: String!, $input: SetlistInput!) {
  updateSetlist(setlistId: $setlistId, input: $input) {
    id
  }
}
    `;
export const useUpdateSetlistMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSetlistMutation, TError, UpdateSetlistMutationVariables, TContext>) =>
    useMutation<UpdateSetlistMutation, TError, UpdateSetlistMutationVariables, TContext>(
      ['UpdateSetlist'],
      useFetchData<UpdateSetlistMutation, UpdateSetlistMutationVariables>(UpdateSetlistDocument),
      options
    );
export const DeleteSetlistDocument = `
    mutation DeleteSetlist($setlistId: String!) {
  deleteSetlist(setlistId: $setlistId) {
    id
  }
}
    `;
export const useDeleteSetlistMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSetlistMutation, TError, DeleteSetlistMutationVariables, TContext>) =>
    useMutation<DeleteSetlistMutation, TError, DeleteSetlistMutationVariables, TContext>(
      ['DeleteSetlist'],
      useFetchData<DeleteSetlistMutation, DeleteSetlistMutationVariables>(DeleteSetlistDocument),
      options
    );
export const GenerateSetlistDocument = `
    mutation GenerateSetlist($teamId: String!, $request: GenerateSetlistDefinitionInput!) {
  generateSetlist(teamId: $teamId, request: $request) {
    positions {
      id
    }
    reasoning
  }
}
    `;
export const useGenerateSetlistMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateSetlistMutation, TError, GenerateSetlistMutationVariables, TContext>) =>
    useMutation<GenerateSetlistMutation, TError, GenerateSetlistMutationVariables, TContext>(
      ['GenerateSetlist'],
      useFetchData<GenerateSetlistMutation, GenerateSetlistMutationVariables>(GenerateSetlistDocument),
      options
    );
export const ClearGenerateSetlistCacheDocument = `
    mutation ClearGenerateSetlistCache {
  clearGenerateSetlistCache
}
    `;
export const useClearGenerateSetlistCacheMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ClearGenerateSetlistCacheMutation, TError, ClearGenerateSetlistCacheMutationVariables, TContext>) =>
    useMutation<ClearGenerateSetlistCacheMutation, TError, ClearGenerateSetlistCacheMutationVariables, TContext>(
      ['ClearGenerateSetlistCache'],
      useFetchData<ClearGenerateSetlistCacheMutation, ClearGenerateSetlistCacheMutationVariables>(ClearGenerateSetlistCacheDocument),
      options
    );
export const GetBiblePassageAnalysisDocument = `
    mutation GetBiblePassageAnalysis($reference: String!) {
  getBiblePassageAnalysis(reference: $reference) {
    emotions {
      emotion
      strength
    }
    thematicKeywords {
      theme
      strength
    }
    theologicalKeywords {
      theology
      strength
    }
  }
}
    `;
export const useGetBiblePassageAnalysisMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetBiblePassageAnalysisMutation, TError, GetBiblePassageAnalysisMutationVariables, TContext>) =>
    useMutation<GetBiblePassageAnalysisMutation, TError, GetBiblePassageAnalysisMutationVariables, TContext>(
      ['GetBiblePassageAnalysis'],
      useFetchData<GetBiblePassageAnalysisMutation, GetBiblePassageAnalysisMutationVariables>(GetBiblePassageAnalysisDocument),
      options
    );
export const GetLyricsAndPassageSummaryDocument = `
    mutation GetLyricsAndPassageSummary($input: LyricsAndPassageSummaryInput!) {
  getLyricsAndPassageSummary(input: $input) {
    passage
    lyrics
    summary
  }
}
    `;
export const useGetLyricsAndPassageSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetLyricsAndPassageSummaryMutation, TError, GetLyricsAndPassageSummaryMutationVariables, TContext>) =>
    useMutation<GetLyricsAndPassageSummaryMutation, TError, GetLyricsAndPassageSummaryMutationVariables, TContext>(
      ['GetLyricsAndPassageSummary'],
      useFetchData<GetLyricsAndPassageSummaryMutation, GetLyricsAndPassageSummaryMutationVariables>(GetLyricsAndPassageSummaryDocument),
      options
    );
export const ListBibleBooksDocument = `
    query ListBibleBooks {
  listBibleBooks {
    name
    code
  }
}
    `;
export const useListBibleBooksQuery = <
      TData = ListBibleBooksQuery,
      TError = unknown
    >(
      variables?: ListBibleBooksQueryVariables,
      options?: UseQueryOptions<ListBibleBooksQuery, TError, TData>
    ) =>
    useQuery<ListBibleBooksQuery, TError, TData>(
      variables === undefined ? ['ListBibleBooks'] : ['ListBibleBooks', variables],
      useFetchData<ListBibleBooksQuery, ListBibleBooksQueryVariables>(ListBibleBooksDocument).bind(null, variables),
      options
    );
export const ListBibleChaptersDocument = `
    query ListBibleChapters($bookCode: String!) {
  listBibleChapters(bookCode: $bookCode) {
    id
    bibleBookCode
    number
  }
}
    `;
export const useListBibleChaptersQuery = <
      TData = ListBibleChaptersQuery,
      TError = unknown
    >(
      variables: ListBibleChaptersQueryVariables,
      options?: UseQueryOptions<ListBibleChaptersQuery, TError, TData>
    ) =>
    useQuery<ListBibleChaptersQuery, TError, TData>(
      ['ListBibleChapters', variables],
      useFetchData<ListBibleChaptersQuery, ListBibleChaptersQueryVariables>(ListBibleChaptersDocument).bind(null, variables),
      options
    );
export const ListBibleVersesDocument = `
    query ListBibleVerses($chapterId: Int!) {
  listBibleVerses(chapterId: $chapterId) {
    reference
    content
    number
  }
}
    `;
export const useListBibleVersesQuery = <
      TData = ListBibleVersesQuery,
      TError = unknown
    >(
      variables: ListBibleVersesQueryVariables,
      options?: UseQueryOptions<ListBibleVersesQuery, TError, TData>
    ) =>
    useQuery<ListBibleVersesQuery, TError, TData>(
      ['ListBibleVerses', variables],
      useFetchData<ListBibleVersesQuery, ListBibleVersesQueryVariables>(ListBibleVersesDocument).bind(null, variables),
      options
    );
export const GetSetlistSummaryDocument = `
    mutation GetSetlistSummary($teamSongIds: [String!]!) {
  getSetlistSummary(teamSongIds: $teamSongIds) {
    summary
    themes
    theology
    gospel_story
    emotions
    energy
    recommendations
  }
}
    `;
export const useGetSetlistSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetSetlistSummaryMutation, TError, GetSetlistSummaryMutationVariables, TContext>) =>
    useMutation<GetSetlistSummaryMutation, TError, GetSetlistSummaryMutationVariables, TContext>(
      ['GetSetlistSummary'],
      useFetchData<GetSetlistSummaryMutation, GetSetlistSummaryMutationVariables>(GetSetlistSummaryDocument),
      options
    );
export const GetSongSummaryDocument = `
    mutation GetSongSummary($teamSongId: String!) {
  getSongSummary(teamSongId: $teamSongId) {
    summary
    themes
    theology
    gospel_story
    emotions
  }
}
    `;
export const useGetSongSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetSongSummaryMutation, TError, GetSongSummaryMutationVariables, TContext>) =>
    useMutation<GetSongSummaryMutation, TError, GetSongSummaryMutationVariables, TContext>(
      ['GetSongSummary'],
      useFetchData<GetSongSummaryMutation, GetSongSummaryMutationVariables>(GetSongSummaryDocument),
      options
    );
export const RequestSongImportUploadDocument = `
    mutation RequestSongImportUpload {
  requestSongImportUpload {
    key
    uploadUrl
  }
}
    `;
export const useRequestSongImportUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestSongImportUploadMutation, TError, RequestSongImportUploadMutationVariables, TContext>) =>
    useMutation<RequestSongImportUploadMutation, TError, RequestSongImportUploadMutationVariables, TContext>(
      ['RequestSongImportUpload'],
      useFetchData<RequestSongImportUploadMutation, RequestSongImportUploadMutationVariables>(RequestSongImportUploadDocument),
      options
    );
export const ReadSongsImportUploadDocument = `
    mutation ReadSongsImportUpload($uploadKey: String!) {
  readSongsImportUpload(uploadKey: $uploadKey) {
    columns
    rowCount
  }
}
    `;
export const useReadSongsImportUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReadSongsImportUploadMutation, TError, ReadSongsImportUploadMutationVariables, TContext>) =>
    useMutation<ReadSongsImportUploadMutation, TError, ReadSongsImportUploadMutationVariables, TContext>(
      ['ReadSongsImportUpload'],
      useFetchData<ReadSongsImportUploadMutation, ReadSongsImportUploadMutationVariables>(ReadSongsImportUploadDocument),
      options
    );
export const VerifySongsImportUploadDocument = `
    mutation VerifySongsImportUpload($uploadKey: String!, $settings: SongImportSettingsInput) {
  verifySongsImportUpload(uploadKey: $uploadKey, settings: $settings) {
    uploadKey
    phase
    createdSongs
    matchedSongs
    totalSongs
    progress
    error
    createdAt
    completedAt
    cancelledAt
  }
}
    `;
export const useVerifySongsImportUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<VerifySongsImportUploadMutation, TError, VerifySongsImportUploadMutationVariables, TContext>) =>
    useMutation<VerifySongsImportUploadMutation, TError, VerifySongsImportUploadMutationVariables, TContext>(
      ['VerifySongsImportUpload'],
      useFetchData<VerifySongsImportUploadMutation, VerifySongsImportUploadMutationVariables>(VerifySongsImportUploadDocument),
      options
    );
export const ProcessSongsImportUploadDocument = `
    mutation ProcessSongsImportUpload($uploadKey: String!, $settings: SongImportSettingsInput) {
  processSongsImportUpload(uploadKey: $uploadKey, settings: $settings) {
    uploadKey
    phase
    createdSongs
    matchedSongs
    totalSongs
    progress
    error
    createdAt
    completedAt
    cancelledAt
  }
}
    `;
export const useProcessSongsImportUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ProcessSongsImportUploadMutation, TError, ProcessSongsImportUploadMutationVariables, TContext>) =>
    useMutation<ProcessSongsImportUploadMutation, TError, ProcessSongsImportUploadMutationVariables, TContext>(
      ['ProcessSongsImportUpload'],
      useFetchData<ProcessSongsImportUploadMutation, ProcessSongsImportUploadMutationVariables>(ProcessSongsImportUploadDocument),
      options
    );
export const CancelSongsImportUploadDocument = `
    mutation CancelSongsImportUpload($uploadKey: String!) {
  cancelSongsImportUpload(uploadKey: $uploadKey) {
    uploadKey
    phase
    createdSongs
    matchedSongs
    totalSongs
    progress
    error
    createdAt
    completedAt
    cancelledAt
  }
}
    `;
export const useCancelSongsImportUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelSongsImportUploadMutation, TError, CancelSongsImportUploadMutationVariables, TContext>) =>
    useMutation<CancelSongsImportUploadMutation, TError, CancelSongsImportUploadMutationVariables, TContext>(
      ['CancelSongsImportUpload'],
      useFetchData<CancelSongsImportUploadMutation, CancelSongsImportUploadMutationVariables>(CancelSongsImportUploadDocument),
      options
    );
export const GetSongsImportDocument = `
    query GetSongsImport($uploadKey: String!) {
  getSongsImport(uploadKey: $uploadKey) {
    uploadKey
    phase
    createdSongs
    matchedSongs
    totalSongs
    progress
    error
    report {
      totalSongs
      matchedSongIds
      existingOnTeam
      newSongs
      missingLyrics
      sample {
        title
        artist
        defaultKey
        artworkUrl
      }
    }
    createdAt
    completedAt
    cancelledAt
  }
}
    `;
export const useGetSongsImportQuery = <
      TData = GetSongsImportQuery,
      TError = unknown
    >(
      variables: GetSongsImportQueryVariables,
      options?: UseQueryOptions<GetSongsImportQuery, TError, TData>
    ) =>
    useQuery<GetSongsImportQuery, TError, TData>(
      ['GetSongsImport', variables],
      useFetchData<GetSongsImportQuery, GetSongsImportQueryVariables>(GetSongsImportDocument).bind(null, variables),
      options
    );
export const GetSongColletionDocument = `
    mutation GetSongColletion($collectionId: String!) {
  getSongCollection(collectionId: $collectionId) {
    songIds
  }
}
    `;
export const useGetSongColletionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetSongColletionMutation, TError, GetSongColletionMutationVariables, TContext>) =>
    useMutation<GetSongColletionMutation, TError, GetSongColletionMutationVariables, TContext>(
      ['GetSongColletion'],
      useFetchData<GetSongColletionMutation, GetSongColletionMutationVariables>(GetSongColletionDocument),
      options
    );
export const GetTeamSongDocument = `
    mutation GetTeamSong($teamSongId: String!) {
  getTeamSong(teamSongId: $teamSongId) {
    appleMusicId
    artist
    artworkUrl
    id
    name
    recommendedKey
    recordedKey
    defaultKey
    spotifyId
    youtubeId
    originSongId
    ccli
    emotionTags
    energyTags
    gospelTags
    themeTags
    songTypeTags
    rotationStatus
    originSongId
    feedback {
      teamSongFeedbackReports {
        setlistId
        teamSongId
        meanPersonalScore
        meanTeamScore
        meanCongregationalScore
        meanTotalSentimentScore
        startAt
      }
      personalScoreQuartiles {
        q1
        q2
        q3
      }
      teamScoreQuartiles {
        q1
        q2
        q3
      }
      congregationalScoreQuartiles {
        q1
        q2
        q3
      }
      overallScore
      trend
    }
    lyrics
    new
    setlists {
      id
      startAt
    }
    analysisOutput {
      summary
      emotions {
        emotion
        strength
      }
      thematicKeywords {
        theme
        strength
      }
      theologicalKeywords {
        theology
        strength
      }
      gospelStory {
        tag
        strength
      }
    }
    analysisStatus
  }
}
    `;
export const useGetTeamSongMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetTeamSongMutation, TError, GetTeamSongMutationVariables, TContext>) =>
    useMutation<GetTeamSongMutation, TError, GetTeamSongMutationVariables, TContext>(
      ['GetTeamSong'],
      useFetchData<GetTeamSongMutation, GetTeamSongMutationVariables>(GetTeamSongDocument),
      options
    );
export const ReanalyzeSongDocument = `
    mutation ReanalyzeSong($songId: String!) {
  reanalyzeSong(songId: $songId) {
    id
    analysisOutput {
      summary
      emotions {
        emotion
        strength
      }
      thematicKeywords {
        theme
        strength
      }
      theologicalKeywords {
        theology
        strength
      }
      gospelStory {
        tag
        strength
      }
    }
    analysisStatus
  }
}
    `;
export const useReanalyzeSongMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReanalyzeSongMutation, TError, ReanalyzeSongMutationVariables, TContext>) =>
    useMutation<ReanalyzeSongMutation, TError, ReanalyzeSongMutationVariables, TContext>(
      ['ReanalyzeSong'],
      useFetchData<ReanalyzeSongMutation, ReanalyzeSongMutationVariables>(ReanalyzeSongDocument),
      options
    );
export const GetSongDocument = `
    mutation GetSong($songId: String!) {
  getSong(songId: $songId) {
    appleMusicId
    artist
    artworkUrl
    id
    name
    recommendedKey
    recordedKey
    spotifyId
    youtubeId
    ccli
    emotionTags
    energyTags
    gospelTags
    songTypeTags
    themeTags
    variations
    lyrics
    analysisOutput {
      summary
      emotions {
        emotion
        strength
      }
      thematicKeywords {
        theme
        strength
      }
      theologicalKeywords {
        theology
        strength
      }
      gospelStory {
        tag
        strength
      }
    }
    analysisStatus
    analyzed
  }
}
    `;
export const useGetSongMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetSongMutation, TError, GetSongMutationVariables, TContext>) =>
    useMutation<GetSongMutation, TError, GetSongMutationVariables, TContext>(
      ['GetSong'],
      useFetchData<GetSongMutation, GetSongMutationVariables>(GetSongDocument),
      options
    );
export const CreateChatDocument = `
    mutation createChat($userIds: [String!]!) {
  upsertChat(userIds: $userIds) {
    id
  }
}
    `;
export const useCreateChatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateChatMutation, TError, CreateChatMutationVariables, TContext>) =>
    useMutation<CreateChatMutation, TError, CreateChatMutationVariables, TContext>(
      ['createChat'],
      useFetchData<CreateChatMutation, CreateChatMutationVariables>(CreateChatDocument),
      options
    );
export const SendChatMessageDocument = `
    mutation sendChatMessage($chatId: String!, $input: MessageInput!) {
  sendChatMessage(chatId: $chatId, input: $input)
}
    `;
export const useSendChatMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendChatMessageMutation, TError, SendChatMessageMutationVariables, TContext>) =>
    useMutation<SendChatMessageMutation, TError, SendChatMessageMutationVariables, TContext>(
      ['sendChatMessage'],
      useFetchData<SendChatMessageMutation, SendChatMessageMutationVariables>(SendChatMessageDocument),
      options
    );
export const GetUserTopTeamSongsDocument = `
    query GetUserTopTeamSongs($userId: String!) {
  getUserTopTeamSongs(userId: $userId) {
    score
    teamSong {
      id
      name
      artist
      artworkUrl
      recordedKey
      recommendedKey
      defaultKey
      rotationStatus
      analysisStatus
    }
  }
}
    `;
export const useGetUserTopTeamSongsQuery = <
      TData = GetUserTopTeamSongsQuery,
      TError = unknown
    >(
      variables: GetUserTopTeamSongsQueryVariables,
      options?: UseQueryOptions<GetUserTopTeamSongsQuery, TError, TData>
    ) =>
    useQuery<GetUserTopTeamSongsQuery, TError, TData>(
      ['GetUserTopTeamSongs', variables],
      useFetchData<GetUserTopTeamSongsQuery, GetUserTopTeamSongsQueryVariables>(GetUserTopTeamSongsDocument).bind(null, variables),
      options
    );
export const UpsertVideoCollectionStatDocument = `
    mutation UpsertVideoCollectionStat($videoCollectionId: String!, $input: VideoCollectionStatInput!) {
  upsertVideoCollectionStat(videoCollectionId: $videoCollectionId, input: $input)
}
    `;
export const useUpsertVideoCollectionStatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertVideoCollectionStatMutation, TError, UpsertVideoCollectionStatMutationVariables, TContext>) =>
    useMutation<UpsertVideoCollectionStatMutation, TError, UpsertVideoCollectionStatMutationVariables, TContext>(
      ['UpsertVideoCollectionStat'],
      useFetchData<UpsertVideoCollectionStatMutation, UpsertVideoCollectionStatMutationVariables>(UpsertVideoCollectionStatDocument),
      options
    );
export const GetChatDocument = `
    query GetChat($chatId: String!, $input: PaginationInput!) {
  getChat(chatId: $chatId) {
    type
    id
    createdAt
    userIds
    users {
      id
      email
      displayName
    }
    userStats {
      userId
      lastSeenAt
    }
    messages(input: $input) {
      count
      items {
        type
        metadata
        content
        createdAt
        id
        userId
        user {
          displayName
          id
        }
        reactions {
          id
          emojiCode
          userId
          messageId
          createdAt
        }
      }
      totalCount
    }
    name
  }
}
    `;
export const useGetChatQuery = <
      TData = GetChatQuery,
      TError = unknown
    >(
      variables: GetChatQueryVariables,
      options?: UseQueryOptions<GetChatQuery, TError, TData>
    ) =>
    useQuery<GetChatQuery, TError, TData>(
      ['GetChat', variables],
      useFetchData<GetChatQuery, GetChatQueryVariables>(GetChatDocument).bind(null, variables),
      options
    );
export const GetChatUserStatsDocument = `
    query GetChatUserStats($chatId: String!) {
  getChat(chatId: $chatId) {
    id
    userStats {
      userId
      lastSeenAt
    }
  }
}
    `;
export const useGetChatUserStatsQuery = <
      TData = GetChatUserStatsQuery,
      TError = unknown
    >(
      variables: GetChatUserStatsQueryVariables,
      options?: UseQueryOptions<GetChatUserStatsQuery, TError, TData>
    ) =>
    useQuery<GetChatUserStatsQuery, TError, TData>(
      ['GetChatUserStats', variables],
      useFetchData<GetChatUserStatsQuery, GetChatUserStatsQueryVariables>(GetChatUserStatsDocument).bind(null, variables),
      options
    );
export const FetchChatMessagesDocument = `
    mutation FetchChatMessages($chatId: String!, $input: PaginationInput!) {
  getChat(chatId: $chatId) {
    id
    messages(input: $input) {
      items {
        type
        metadata
        content
        createdAt
        id
        userId
        user {
          displayName
          id
        }
        reactions {
          id
          emojiCode
          userId
          messageId
          createdAt
        }
      }
      totalCount
    }
  }
}
    `;
export const useFetchChatMessagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FetchChatMessagesMutation, TError, FetchChatMessagesMutationVariables, TContext>) =>
    useMutation<FetchChatMessagesMutation, TError, FetchChatMessagesMutationVariables, TContext>(
      ['FetchChatMessages'],
      useFetchData<FetchChatMessagesMutation, FetchChatMessagesMutationVariables>(FetchChatMessagesDocument),
      options
    );
export const FetchChatReactionsDocument = `
    mutation FetchChatReactions($chatId: String!, $fromDate: String, $toDate: String) {
  getChatReactions(chatId: $chatId, fromDate: $fromDate, toDate: $toDate) {
    id
    emojiCode
    userId
    messageId
    createdAt
  }
}
    `;
export const useFetchChatReactionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FetchChatReactionsMutation, TError, FetchChatReactionsMutationVariables, TContext>) =>
    useMutation<FetchChatReactionsMutation, TError, FetchChatReactionsMutationVariables, TContext>(
      ['FetchChatReactions'],
      useFetchData<FetchChatReactionsMutation, FetchChatReactionsMutationVariables>(FetchChatReactionsDocument),
      options
    );
export const FetchMessageReactionsDocument = `
    mutation FetchMessageReactions($messageId: String!) {
  getMessageReactions(messageId: $messageId) {
    id
    emojiCode
    userId
    messageId
    createdAt
  }
}
    `;
export const useFetchMessageReactionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FetchMessageReactionsMutation, TError, FetchMessageReactionsMutationVariables, TContext>) =>
    useMutation<FetchMessageReactionsMutation, TError, FetchMessageReactionsMutationVariables, TContext>(
      ['FetchMessageReactions'],
      useFetchData<FetchMessageReactionsMutation, FetchMessageReactionsMutationVariables>(FetchMessageReactionsDocument),
      options
    );
export const UpdateChatDocument = `
    mutation UpdateChat($chatId: String!, $userIds: [String!]!) {
  updateChat(chatId: $chatId, userIds: $userIds) {
    id
  }
}
    `;
export const useUpdateChatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateChatMutation, TError, UpdateChatMutationVariables, TContext>) =>
    useMutation<UpdateChatMutation, TError, UpdateChatMutationVariables, TContext>(
      ['UpdateChat'],
      useFetchData<UpdateChatMutation, UpdateChatMutationVariables>(UpdateChatDocument),
      options
    );
export const RenameChatDocument = `
    mutation RenameChat($chatId: String!, $name: String) {
  renameChat(chatId: $chatId, name: $name) {
    id
  }
}
    `;
export const useRenameChatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RenameChatMutation, TError, RenameChatMutationVariables, TContext>) =>
    useMutation<RenameChatMutation, TError, RenameChatMutationVariables, TContext>(
      ['RenameChat'],
      useFetchData<RenameChatMutation, RenameChatMutationVariables>(RenameChatDocument),
      options
    );
export const LeaveChatDocument = `
    mutation LeaveChat($chatId: String!) {
  leaveChat(chatId: $chatId) {
    id
  }
}
    `;
export const useLeaveChatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LeaveChatMutation, TError, LeaveChatMutationVariables, TContext>) =>
    useMutation<LeaveChatMutation, TError, LeaveChatMutationVariables, TContext>(
      ['LeaveChat'],
      useFetchData<LeaveChatMutation, LeaveChatMutationVariables>(LeaveChatDocument),
      options
    );
export const UpsertChatStatDocument = `
    mutation UpsertChatStat($chatId: String!) {
  upsertChatStat(chatId: $chatId) {
    lastSeenAt
  }
}
    `;
export const useUpsertChatStatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertChatStatMutation, TError, UpsertChatStatMutationVariables, TContext>) =>
    useMutation<UpsertChatStatMutation, TError, UpsertChatStatMutationVariables, TContext>(
      ['UpsertChatStat'],
      useFetchData<UpsertChatStatMutation, UpsertChatStatMutationVariables>(UpsertChatStatDocument),
      options
    );
export const SendChatTypingStatusDocument = `
    mutation SendChatTypingStatus($chatId: String!) {
  sendChatTypingStatus(chatId: $chatId)
}
    `;
export const useSendChatTypingStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendChatTypingStatusMutation, TError, SendChatTypingStatusMutationVariables, TContext>) =>
    useMutation<SendChatTypingStatusMutation, TError, SendChatTypingStatusMutationVariables, TContext>(
      ['SendChatTypingStatus'],
      useFetchData<SendChatTypingStatusMutation, SendChatTypingStatusMutationVariables>(SendChatTypingStatusDocument),
      options
    );
export const GetDashboardDocument = `
    query GetDashboard {
  getDashboard {
    videoCollections {
      id
      name
      paid
      onboarding
      stat {
        canBeCompleted
        completed
      }
      hex
      videos {
        description
        duration
        id
        name
        paid
        stat {
          fullyWatched
          percentagePlayed
        }
        thumbnailUrl
        contributor {
          name
          imageUrl
        }
        url
        chat {
          id
        }
      }
    }
  }
}
    `;
export const useGetDashboardQuery = <
      TData = GetDashboardQuery,
      TError = unknown
    >(
      variables?: GetDashboardQueryVariables,
      options?: UseQueryOptions<GetDashboardQuery, TError, TData>
    ) =>
    useQuery<GetDashboardQuery, TError, TData>(
      variables === undefined ? ['GetDashboard'] : ['GetDashboard', variables],
      useFetchData<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument).bind(null, variables),
      options
    );
export const TestNotificationDocument = `
    mutation TestNotification($input: TestNotificationsInput) {
  testNotifications(input: $input)
}
    `;
export const useTestNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TestNotificationMutation, TError, TestNotificationMutationVariables, TContext>) =>
    useMutation<TestNotificationMutation, TError, TestNotificationMutationVariables, TContext>(
      ['TestNotification'],
      useFetchData<TestNotificationMutation, TestNotificationMutationVariables>(TestNotificationDocument),
      options
    );
export const ListMySetlistFeedbackRequestsDocument = `
    query ListMySetlistFeedbackRequests {
  listMySetlistFeedbackRequests {
    id
  }
}
    `;
export const useListMySetlistFeedbackRequestsQuery = <
      TData = ListMySetlistFeedbackRequestsQuery,
      TError = unknown
    >(
      variables?: ListMySetlistFeedbackRequestsQueryVariables,
      options?: UseQueryOptions<ListMySetlistFeedbackRequestsQuery, TError, TData>
    ) =>
    useQuery<ListMySetlistFeedbackRequestsQuery, TError, TData>(
      variables === undefined ? ['ListMySetlistFeedbackRequests'] : ['ListMySetlistFeedbackRequests', variables],
      useFetchData<ListMySetlistFeedbackRequestsQuery, ListMySetlistFeedbackRequestsQueryVariables>(ListMySetlistFeedbackRequestsDocument).bind(null, variables),
      options
    );
export const CreateSetlistFeedbackSubmissionDocument = `
    mutation CreateSetlistFeedbackSubmission($input: SetlistFeedbackSubmissionInput!) {
  createSetlistFeedbackSubmission(input: $input) {
    id
    teamSongFeedbackSubmissionIds
    teamSongFeedbackSubmissions {
      id
    }
  }
}
    `;
export const useCreateSetlistFeedbackSubmissionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSetlistFeedbackSubmissionMutation, TError, CreateSetlistFeedbackSubmissionMutationVariables, TContext>) =>
    useMutation<CreateSetlistFeedbackSubmissionMutation, TError, CreateSetlistFeedbackSubmissionMutationVariables, TContext>(
      ['CreateSetlistFeedbackSubmission'],
      useFetchData<CreateSetlistFeedbackSubmissionMutation, CreateSetlistFeedbackSubmissionMutationVariables>(CreateSetlistFeedbackSubmissionDocument),
      options
    );
export const ListMyChatsDocument = `
    query listMyChats($input: PaginationInput!) {
  listMyChats {
    id
    createdAt
    type
    userIds
    users {
      id
      displayName
    }
    messages(input: $input) {
      items {
        createdAt
        userId
        user {
          id
          displayName
        }
        content
      }
    }
    name
  }
}
    `;
export const useListMyChatsQuery = <
      TData = ListMyChatsQuery,
      TError = unknown
    >(
      variables: ListMyChatsQueryVariables,
      options?: UseQueryOptions<ListMyChatsQuery, TError, TData>
    ) =>
    useQuery<ListMyChatsQuery, TError, TData>(
      ['listMyChats', variables],
      useFetchData<ListMyChatsQuery, ListMyChatsQueryVariables>(ListMyChatsDocument).bind(null, variables),
      options
    );
export const ListTeamVideoChatsDocument = `
    query ListTeamVideoChats($input: PaginationInput!) {
  listTeamVideoChats {
    id
    messages(input: $input) {
      items {
        createdAt
        user {
          displayName
        }
        content
      }
    }
    video {
      id
      name
      thumbnailUrl
    }
  }
}
    `;
export const useListTeamVideoChatsQuery = <
      TData = ListTeamVideoChatsQuery,
      TError = unknown
    >(
      variables: ListTeamVideoChatsQueryVariables,
      options?: UseQueryOptions<ListTeamVideoChatsQuery, TError, TData>
    ) =>
    useQuery<ListTeamVideoChatsQuery, TError, TData>(
      ['ListTeamVideoChats', variables],
      useFetchData<ListTeamVideoChatsQuery, ListTeamVideoChatsQueryVariables>(ListTeamVideoChatsDocument).bind(null, variables),
      options
    );
export const GetDashboardOnboardingDocument = `
    query GetDashboardOnboarding {
  getDashboard {
    videoCollections {
      id
      onboarding
      videos {
        id
      }
    }
  }
}
    `;
export const useGetDashboardOnboardingQuery = <
      TData = GetDashboardOnboardingQuery,
      TError = unknown
    >(
      variables?: GetDashboardOnboardingQueryVariables,
      options?: UseQueryOptions<GetDashboardOnboardingQuery, TError, TData>
    ) =>
    useQuery<GetDashboardOnboardingQuery, TError, TData>(
      variables === undefined ? ['GetDashboardOnboarding'] : ['GetDashboardOnboarding', variables],
      useFetchData<GetDashboardOnboardingQuery, GetDashboardOnboardingQueryVariables>(GetDashboardOnboardingDocument).bind(null, variables),
      options
    );
export const GetReelFeedDocument = `
    query GetReelFeed {
  getReelFeed {
    id
    name
    url
    stat {
      liked
    }
    posterUrl
    videoId
    video {
      name
      description
      contributor {
        name
        imageUrl
      }
      videoCollection {
        name
        hex
      }
    }
    stat {
      liked
    }
  }
}
    `;
export const useGetReelFeedQuery = <
      TData = GetReelFeedQuery,
      TError = unknown
    >(
      variables?: GetReelFeedQueryVariables,
      options?: UseQueryOptions<GetReelFeedQuery, TError, TData>
    ) =>
    useQuery<GetReelFeedQuery, TError, TData>(
      variables === undefined ? ['GetReelFeed'] : ['GetReelFeed', variables],
      useFetchData<GetReelFeedQuery, GetReelFeedQueryVariables>(GetReelFeedDocument).bind(null, variables),
      options
    );
export const UpsertReelStatDocument = `
    mutation UpsertReelStat($reelId: String!, $input: ReelStatInput!) {
  upsertReelStat(reelId: $reelId, input: $input) {
    liked
  }
}
    `;
export const useUpsertReelStatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertReelStatMutation, TError, UpsertReelStatMutationVariables, TContext>) =>
    useMutation<UpsertReelStatMutation, TError, UpsertReelStatMutationVariables, TContext>(
      ['UpsertReelStat'],
      useFetchData<UpsertReelStatMutation, UpsertReelStatMutationVariables>(UpsertReelStatDocument),
      options
    );
export const ListMyTeamSetlistsForReportsDocument = `
    query ListMyTeamSetlistsForReports {
  listMyTeamSetlists {
    id
    serviceId
    startAt
    draft
    teamSongIds
    feedback {
      submissions {
        userId
        teamSongFeedbackSubmissions {
          teamSongId
          personalScore
          teamScore
          congregationalScore
        }
      }
    }
  }
}
    `;
export const useListMyTeamSetlistsForReportsQuery = <
      TData = ListMyTeamSetlistsForReportsQuery,
      TError = unknown
    >(
      variables?: ListMyTeamSetlistsForReportsQueryVariables,
      options?: UseQueryOptions<ListMyTeamSetlistsForReportsQuery, TError, TData>
    ) =>
    useQuery<ListMyTeamSetlistsForReportsQuery, TError, TData>(
      variables === undefined ? ['ListMyTeamSetlistsForReports'] : ['ListMyTeamSetlistsForReports', variables],
      useFetchData<ListMyTeamSetlistsForReportsQuery, ListMyTeamSetlistsForReportsQueryVariables>(ListMyTeamSetlistsForReportsDocument).bind(null, variables),
      options
    );
export const UpdateTeamSongDocument = `
    mutation UpdateTeamSong($teamSongId: String!, $input: TeamSongInput!) {
  updateTeamSong(teamSongId: $teamSongId, input: $input) {
    appleMusicId
    artist
    artworkUrl
    id
    name
    recommendedKey
    recordedKey
    defaultKey
    spotifyId
    youtubeId
    originSongId
    ccli
    emotionTags
    energyTags
    gospelTags
    songTypeTags
    rotationStatus
    originSongId
    lyrics
    new
  }
}
    `;
export const useUpdateTeamSongMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTeamSongMutation, TError, UpdateTeamSongMutationVariables, TContext>) =>
    useMutation<UpdateTeamSongMutation, TError, UpdateTeamSongMutationVariables, TContext>(
      ['UpdateTeamSong'],
      useFetchData<UpdateTeamSongMutation, UpdateTeamSongMutationVariables>(UpdateTeamSongDocument),
      options
    );
export const DeleteTeamSongDocument = `
    mutation DeleteTeamSong($teamSongId: String!) {
  deleteTeamSong(teamSongId: $teamSongId) {
    id
    name
  }
}
    `;
export const useDeleteTeamSongMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTeamSongMutation, TError, DeleteTeamSongMutationVariables, TContext>) =>
    useMutation<DeleteTeamSongMutation, TError, DeleteTeamSongMutationVariables, TContext>(
      ['DeleteTeamSong'],
      useFetchData<DeleteTeamSongMutation, DeleteTeamSongMutationVariables>(DeleteTeamSongDocument),
      options
    );
export const GetVideoDocument = `
    query GetVideo($getVideoId: String!, $input: PaginationInput!) {
  getVideo(id: $getVideoId) {
    contributor {
      imageUrl
      description
      role
      id
      name
      videoIds
    }
    description
    duration
    id
    name
    paid
    posterUrl
    stat {
      fullyWatched
      percentagePlayed
    }
    thumbnailUrl
    url
    chat {
      id
      type
      userStats {
        userId
        lastSeenAt
      }
      messages(input: $input) {
        items {
          type
          metadata
          content
          createdAt
          id
          userId
          user {
            displayName
            id
          }
          reactions {
            id
            emojiCode
            userId
            messageId
            createdAt
          }
        }
        totalCount
      }
    }
    videoCollection {
      id
      name
      onboarding
      videos {
        id
        name
        paid
        description
        duration
        id
        name
        paid
        posterUrl
        thumbnailUrl
        url
      }
      videoIds
    }
  }
}
    `;
export const useGetVideoQuery = <
      TData = GetVideoQuery,
      TError = unknown
    >(
      variables: GetVideoQueryVariables,
      options?: UseQueryOptions<GetVideoQuery, TError, TData>
    ) =>
    useQuery<GetVideoQuery, TError, TData>(
      ['GetVideo', variables],
      useFetchData<GetVideoQuery, GetVideoQueryVariables>(GetVideoDocument).bind(null, variables),
      options
    );
export const FetchVideoChatMessagesDocument = `
    mutation FetchVideoChatMessages($videoId: String!, $input: PaginationInput!) {
  getVideoChat(videoId: $videoId) {
    id
    type
    userStats {
      userId
      lastSeenAt
    }
    messages(input: $input) {
      items {
        type
        metadata
        content
        createdAt
        id
        userId
        user {
          displayName
          id
        }
        reactions {
          id
          emojiCode
          userId
          messageId
          createdAt
        }
      }
      totalCount
    }
  }
}
    `;
export const useFetchVideoChatMessagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FetchVideoChatMessagesMutation, TError, FetchVideoChatMessagesMutationVariables, TContext>) =>
    useMutation<FetchVideoChatMessagesMutation, TError, FetchVideoChatMessagesMutationVariables, TContext>(
      ['FetchVideoChatMessages'],
      useFetchData<FetchVideoChatMessagesMutation, FetchVideoChatMessagesMutationVariables>(FetchVideoChatMessagesDocument),
      options
    );
export const SendVideoChatMessageDocument = `
    mutation SendVideoChatMessage($videoId: String!, $input: MessageInput!) {
  sendVideoChatMessage(videoId: $videoId, input: $input)
}
    `;
export const useSendVideoChatMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendVideoChatMessageMutation, TError, SendVideoChatMessageMutationVariables, TContext>) =>
    useMutation<SendVideoChatMessageMutation, TError, SendVideoChatMessageMutationVariables, TContext>(
      ['SendVideoChatMessage'],
      useFetchData<SendVideoChatMessageMutation, SendVideoChatMessageMutationVariables>(SendVideoChatMessageDocument),
      options
    );
export const UpsertVideoStatDocument = `
    mutation UpsertVideoStat($videoId: String!, $input: VideoStatInput!) {
  upsertVideoStat(videoId: $videoId, input: $input) {
    percentagePlayed
  }
}
    `;
export const useUpsertVideoStatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertVideoStatMutation, TError, UpsertVideoStatMutationVariables, TContext>) =>
    useMutation<UpsertVideoStatMutation, TError, UpsertVideoStatMutationVariables, TContext>(
      ['UpsertVideoStat'],
      useFetchData<UpsertVideoStatMutation, UpsertVideoStatMutationVariables>(UpsertVideoStatDocument),
      options
    );
export const UpdateLastSeenAtDocument = `
    mutation UpdateLastSeenAt {
  updateLastSeenAt {
    lastSeenAt
  }
}
    `;
export const useUpdateLastSeenAtMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLastSeenAtMutation, TError, UpdateLastSeenAtMutationVariables, TContext>) =>
    useMutation<UpdateLastSeenAtMutation, TError, UpdateLastSeenAtMutationVariables, TContext>(
      ['UpdateLastSeenAt'],
      useFetchData<UpdateLastSeenAtMutation, UpdateLastSeenAtMutationVariables>(UpdateLastSeenAtDocument),
      options
    );
export const GetMyUserDocument = `
    query getMyUser {
  getMyUser {
    id
    displayName
    email
    notificationId
    lastSeenAt
    gender
    birthYear
    color
    role
    skills
    completedMilestones
    notificationPreferences {
      chat
      videoChat
      videoChatActiveOnly
      groupChat
      reEngagementNudge
    }
  }
}
    `;
export const useGetMyUserQuery = <
      TData = GetMyUserQuery,
      TError = unknown
    >(
      variables?: GetMyUserQueryVariables,
      options?: UseQueryOptions<GetMyUserQuery, TError, TData>
    ) =>
    useQuery<GetMyUserQuery, TError, TData>(
      variables === undefined ? ['getMyUser'] : ['getMyUser', variables],
      useFetchData<GetMyUserQuery, GetMyUserQueryVariables>(GetMyUserDocument).bind(null, variables),
      options
    );
export const UpdateMyUserDocument = `
    mutation updateMyUser($input: UserInput!) {
  updateMyUser(input: $input) {
    id
    displayName
    email
    notificationId
    lastSeenAt
    gender
    birthYear
    color
    role
    skills
    completedMilestones
    notificationPreferences {
      chat
      videoChat
      videoChatActiveOnly
      groupChat
      reEngagementNudge
    }
  }
}
    `;
export const useUpdateMyUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMyUserMutation, TError, UpdateMyUserMutationVariables, TContext>) =>
    useMutation<UpdateMyUserMutation, TError, UpdateMyUserMutationVariables, TContext>(
      ['updateMyUser'],
      useFetchData<UpdateMyUserMutation, UpdateMyUserMutationVariables>(UpdateMyUserDocument),
      options
    );
export const GetMyPermissionsDocument = `
    query getMyPermissions {
  getMyPermissions
}
    `;
export const useGetMyPermissionsQuery = <
      TData = GetMyPermissionsQuery,
      TError = unknown
    >(
      variables?: GetMyPermissionsQueryVariables,
      options?: UseQueryOptions<GetMyPermissionsQuery, TError, TData>
    ) =>
    useQuery<GetMyPermissionsQuery, TError, TData>(
      variables === undefined ? ['getMyPermissions'] : ['getMyPermissions', variables],
      useFetchData<GetMyPermissionsQuery, GetMyPermissionsQueryVariables>(GetMyPermissionsDocument).bind(null, variables),
      options
    );
export const ListTeamServiceDocument = `
    query ListTeamService {
  listTeamServices {
    id
    name
    startAt
    day
    size
  }
}
    `;
export const useListTeamServiceQuery = <
      TData = ListTeamServiceQuery,
      TError = unknown
    >(
      variables?: ListTeamServiceQueryVariables,
      options?: UseQueryOptions<ListTeamServiceQuery, TError, TData>
    ) =>
    useQuery<ListTeamServiceQuery, TError, TData>(
      variables === undefined ? ['ListTeamService'] : ['ListTeamService', variables],
      useFetchData<ListTeamServiceQuery, ListTeamServiceQueryVariables>(ListTeamServiceDocument).bind(null, variables),
      options
    );
export const ListMyTeamSetlistsDocument = `
    query ListMyTeamSetlists {
  listMyTeamSetlists {
    id
    userId
    serviceId
    startAt
    feedback {
      personalScoreQuartiles {
        q1
        q2
        q3
      }
      teamScoreQuartiles {
        q1
        q2
        q3
      }
      congregationalScoreQuartiles {
        q1
        q2
        q3
      }
      teamSongFeedbackReports {
        teamSongId
        setlistId
        meanPersonalScore
        meanTeamScore
        meanCongregationalScore
        meanTotalSentimentScore
      }
      submissions {
        userId
        teamSongFeedbackSubmissionIds
      }
      overallScore
    }
    submissions {
      userId
      teamSongFeedbackSubmissionIds
    }
    teamSongIds
    teamSongOverrides {
      id
      defaultKey
    }
    createdAt
    draft
    generateSettings {
      totalSongPositions
      postSermonSongPosition
      searchTerm
      bibleVerseReference
      bibleReference
    }
  }
}
    `;
export const useListMyTeamSetlistsQuery = <
      TData = ListMyTeamSetlistsQuery,
      TError = unknown
    >(
      variables?: ListMyTeamSetlistsQueryVariables,
      options?: UseQueryOptions<ListMyTeamSetlistsQuery, TError, TData>
    ) =>
    useQuery<ListMyTeamSetlistsQuery, TError, TData>(
      variables === undefined ? ['ListMyTeamSetlists'] : ['ListMyTeamSetlists', variables],
      useFetchData<ListMyTeamSetlistsQuery, ListMyTeamSetlistsQueryVariables>(ListMyTeamSetlistsDocument).bind(null, variables),
      options
    );
export const GetSubscriptionSessionDocument = `
    mutation GetSubscriptionSession {
  getChargebeePortalSession
}
    `;
export const useGetSubscriptionSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetSubscriptionSessionMutation, TError, GetSubscriptionSessionMutationVariables, TContext>) =>
    useMutation<GetSubscriptionSessionMutation, TError, GetSubscriptionSessionMutationVariables, TContext>(
      ['GetSubscriptionSession'],
      useFetchData<GetSubscriptionSessionMutation, GetSubscriptionSessionMutationVariables>(GetSubscriptionSessionDocument),
      options
    );
export const LinkTeamChargebeeCustomerDocument = `
    mutation LinkTeamChargebeeCustomer {
  linkTeamChargebeeCustomer
}
    `;
export const useLinkTeamChargebeeCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LinkTeamChargebeeCustomerMutation, TError, LinkTeamChargebeeCustomerMutationVariables, TContext>) =>
    useMutation<LinkTeamChargebeeCustomerMutation, TError, LinkTeamChargebeeCustomerMutationVariables, TContext>(
      ['LinkTeamChargebeeCustomer'],
      useFetchData<LinkTeamChargebeeCustomerMutation, LinkTeamChargebeeCustomerMutationVariables>(LinkTeamChargebeeCustomerDocument),
      options
    );
export const IsChargebeeCouponUsableDocument = `
    query IsChargebeeCouponUsable($couponId: String!) {
  isChargebeeCouponUsable(couponId: $couponId)
}
    `;
export const useIsChargebeeCouponUsableQuery = <
      TData = IsChargebeeCouponUsableQuery,
      TError = unknown
    >(
      variables: IsChargebeeCouponUsableQueryVariables,
      options?: UseQueryOptions<IsChargebeeCouponUsableQuery, TError, TData>
    ) =>
    useQuery<IsChargebeeCouponUsableQuery, TError, TData>(
      ['IsChargebeeCouponUsable', variables],
      useFetchData<IsChargebeeCouponUsableQuery, IsChargebeeCouponUsableQueryVariables>(IsChargebeeCouponUsableDocument).bind(null, variables),
      options
    );
export const CheckSubscriptionStatusDocument = `
    query CheckSubscriptionStatus {
  checkAndSetChargebeeSubscription
}
    `;
export const useCheckSubscriptionStatusQuery = <
      TData = CheckSubscriptionStatusQuery,
      TError = unknown
    >(
      variables?: CheckSubscriptionStatusQueryVariables,
      options?: UseQueryOptions<CheckSubscriptionStatusQuery, TError, TData>
    ) =>
    useQuery<CheckSubscriptionStatusQuery, TError, TData>(
      variables === undefined ? ['CheckSubscriptionStatus'] : ['CheckSubscriptionStatus', variables],
      useFetchData<CheckSubscriptionStatusQuery, CheckSubscriptionStatusQueryVariables>(CheckSubscriptionStatusDocument).bind(null, variables),
      options
    );
export const TeamActionDocument = `
    subscription teamAction {
  teamAction {
    action
    resourceIds
    actorId
  }
}
    `;
export const GetMyTeamDocument = `
    query getMyTeam {
  getMyTeam {
    id
    name
    subscriptionStatus
    inviteLinkCode
    invites {
      id
      email
    }
    members {
      roles
      user {
        id
        displayName
        email
        lastSeenAt
        color
        skills
        birthYear
        role
        gender
      }
    }
    country
    city
    denomination
    chartRepositoryUrl
  }
}
    `;
export const useGetMyTeamQuery = <
      TData = GetMyTeamQuery,
      TError = unknown
    >(
      variables?: GetMyTeamQueryVariables,
      options?: UseQueryOptions<GetMyTeamQuery, TError, TData>
    ) =>
    useQuery<GetMyTeamQuery, TError, TData>(
      variables === undefined ? ['getMyTeam'] : ['getMyTeam', variables],
      useFetchData<GetMyTeamQuery, GetMyTeamQueryVariables>(GetMyTeamDocument).bind(null, variables),
      options
    );
export const UpdateMyTeamDocument = `
    mutation UpdateMyTeam($input: TeamInput!) {
  updateMyTeam(input: $input) {
    name
    chartRepositoryUrl
  }
}
    `;
export const useUpdateMyTeamMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMyTeamMutation, TError, UpdateMyTeamMutationVariables, TContext>) =>
    useMutation<UpdateMyTeamMutation, TError, UpdateMyTeamMutationVariables, TContext>(
      ['UpdateMyTeam'],
      useFetchData<UpdateMyTeamMutation, UpdateMyTeamMutationVariables>(UpdateMyTeamDocument),
      options
    );
export const ListTeamSongsDocument = `
    query ListTeamSongs {
  listMyTeamSongs {
    artist
    artworkUrl
    id
    name
    recommendedKey
    recordedKey
    defaultKey
    originSongId
    ccli
    emotionTags
    energyTags
    gospelTags
    themeTags
    songTypeTags
    rotationStatus
    feedback {
      teamSongFeedbackReports {
        startAt
        meanPersonalScore
        meanTeamScore
        meanCongregationalScore
      }
      overallScore
      trend
    }
    lyrics
    new
    setlists {
      id
      startAt
    }
    analysisOutput {
      emotions {
        emotion
        strength
      }
      thematicKeywords {
        theme
        strength
      }
      theologicalKeywords {
        theology
        strength
      }
      gospelStory {
        tag
        strength
      }
    }
    analysisStatus
  }
}
    `;
export const useListTeamSongsQuery = <
      TData = ListTeamSongsQuery,
      TError = unknown
    >(
      variables?: ListTeamSongsQueryVariables,
      options?: UseQueryOptions<ListTeamSongsQuery, TError, TData>
    ) =>
    useQuery<ListTeamSongsQuery, TError, TData>(
      variables === undefined ? ['ListTeamSongs'] : ['ListTeamSongs', variables],
      useFetchData<ListTeamSongsQuery, ListTeamSongsQueryVariables>(ListTeamSongsDocument).bind(null, variables),
      options
    );
export const ListMyUnreadChatsDocument = `
    query ListMyUnreadChats {
  listMyChats(unreadOnly: true) {
    id
  }
}
    `;
export const useListMyUnreadChatsQuery = <
      TData = ListMyUnreadChatsQuery,
      TError = unknown
    >(
      variables?: ListMyUnreadChatsQueryVariables,
      options?: UseQueryOptions<ListMyUnreadChatsQuery, TError, TData>
    ) =>
    useQuery<ListMyUnreadChatsQuery, TError, TData>(
      variables === undefined ? ['ListMyUnreadChats'] : ['ListMyUnreadChats', variables],
      useFetchData<ListMyUnreadChatsQuery, ListMyUnreadChatsQueryVariables>(ListMyUnreadChatsDocument).bind(null, variables),
      options
    );
export const ListTeamUnreadVideoChatsDocument = `
    query ListTeamUnreadVideoChats {
  listTeamVideoChats(unreadOnly: true) {
    id
  }
}
    `;
export const useListTeamUnreadVideoChatsQuery = <
      TData = ListTeamUnreadVideoChatsQuery,
      TError = unknown
    >(
      variables?: ListTeamUnreadVideoChatsQueryVariables,
      options?: UseQueryOptions<ListTeamUnreadVideoChatsQuery, TError, TData>
    ) =>
    useQuery<ListTeamUnreadVideoChatsQuery, TError, TData>(
      variables === undefined ? ['ListTeamUnreadVideoChats'] : ['ListTeamUnreadVideoChats', variables],
      useFetchData<ListTeamUnreadVideoChatsQuery, ListTeamUnreadVideoChatsQueryVariables>(ListTeamUnreadVideoChatsDocument).bind(null, variables),
      options
    );